(function () {
  'use strict';
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var toastEntries = [];
  var shippingToastUnlocked = null;
  var shippingToastTimer;
  var drawerCloseTimer;
  var drawerOpenRequest = 0;
  var drawerRenderVersion = 0;
  var cartProductRequests = Object.create(null);
  var nativeComplementsRequest = null;
  var cartAddQueue = Promise.resolve();
  var currentCartItemCount = null;
  var lastDialogTrigger = null;
  var lastMenuTrigger = null;
  var ambientObserver = null;
  var pendingCartCoupon = '';
  var cartCouponExpanded = false;

  function appendCartCoupon(footer, checkout) {
    var disclosure = document.createElement('div');
    disclosure.className = 'gd-cart-coupon-disclosure';
    disclosure.classList.toggle('is-open', cartCouponExpanded);
    var summary = document.createElement('button');
    summary.type = 'button';
    summary.className = 'gd-cart-coupon-disclosure__toggle';
    summary.textContent = 'Clique aqui para adicionar um cupom.';
    summary.setAttribute('aria-controls', 'GdCartCouponPanel');
    summary.setAttribute('aria-expanded', String(cartCouponExpanded));
    var arrow = document.createElement('span');
    arrow.className = 'gd-cart-coupon-disclosure__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2"><path d="m6 9 6 6 6-6"/></svg>';
    summary.appendChild(arrow);
    var couponTitle = document.createElement('p');
    couponTitle.className = 'gd-cart-coupon-disclosure__title';
    couponTitle.textContent = 'Cupom de desconto';
    disclosure.appendChild(couponTitle);
    var form = document.createElement('form');
    form.id = 'GdCartCouponPanel';
    form.className = 'gd-cart-coupon';
    form.hidden = !cartCouponExpanded;
    summary.addEventListener('click', function () {
      cartCouponExpanded = !cartCouponExpanded;
      form.hidden = !cartCouponExpanded;
      summary.setAttribute('aria-expanded', String(cartCouponExpanded));
      disclosure.classList.toggle('is-open', cartCouponExpanded);
      if (cartCouponExpanded) requestAnimationFrame(function () { summary.scrollIntoView({ block: 'end', behavior: 'auto' }); });
    });
    var label = document.createElement('label');
    label.htmlFor = 'GdCartCoupon';
    label.textContent = 'Cupom de desconto';
    var row = document.createElement('div');
    row.className = 'gd-cart-coupon__row';
    var input = document.createElement('input');
    input.id = 'GdCartCoupon';
    input.type = 'text';
    input.maxLength = 100;
    input.autocomplete = 'off';
    input.placeholder = 'Digite seu cupom';
    input.value = pendingCartCoupon;
    input.setAttribute('aria-describedby', 'GdCartCouponStatus');
    var apply = document.createElement('button');
    apply.type = 'submit';
    apply.textContent = 'Aplicar';
    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'gd-cart-coupon__remove';
    remove.textContent = 'Remover cupom';
    var status = document.createElement('div');
    status.id = 'GdCartCouponStatus';
    status.setAttribute('role', 'status');
    function syncCoupon() {
      checkout.href = rootUrl + 'checkout';
      remove.hidden = !pendingCartCoupon;
      status.textContent = pendingCartCoupon
        ? 'Código ' + pendingCartCoupon + ' aplicado ao carrinho.'
        : 'Digite um cupom para ver o desconto no carrinho.';
    }
    function updateCoupon(code) {
      apply.disabled = true;
      remove.disabled = true;
      status.textContent = code ? 'Aplicando cupom…' : 'Removendo cupom…';
      return updateCart({ discount: code }).then(function (cart) {
        var applicable = code && ((cart.discount_codes || []).some(function (discount) {
          return String(discount.code || '').toLowerCase() === code.toLowerCase() && discount.applicable !== false;
        }) || (cart.cart_level_discount_applications || []).some(function (discount) {
          return String(discount.title || discount.code || '').toLowerCase() === code.toLowerCase();
        }));
        pendingCartCoupon = applicable ? code : '';
        setCartCount(cart.item_count);
        updateCommercialProgress(cart);
        updateMobileCartPreview(cart);
        status.textContent = code && !applicable
          ? 'Cupom inválido ou não aplicável a este carrinho.'
          : (code ? 'Código ' + code + ' aplicado ao carrinho.' : 'Cupom removido do carrinho.');
        showToast(code && !applicable ? 'Cupom inválido ou não aplicável a este carrinho.' : (code ? 'Cupom ' + code + ' aplicado ao carrinho.' : 'Cupom removido do carrinho.'));
        return renderDrawerFast(cart);
      }).catch(function (error) {
        status.textContent = error.message || 'Não foi possível atualizar o cupom.';
        apply.disabled = false;
        remove.disabled = false;
      });
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!input.value.trim()) {
        status.textContent = 'Digite o código do cupom.';
        input.focus();
        return;
      }
      updateCoupon(input.value.trim());
    });
    remove.addEventListener('click', function () {
      updateCoupon('');
    });
    row.appendChild(input);
    row.appendChild(apply);
    form.appendChild(label);
    form.appendChild(row);
    form.appendChild(status);
    form.appendChild(remove);
    syncCoupon();
    disclosure.appendChild(summary);
    disclosure.appendChild(form);
    footer.appendChild(disclosure);
  }

  function analyticsAllowed() {
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
      return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    }
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.currentVisitorConsent === 'function') {
      var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      return Boolean(consent && consent.analytics === true);
    }
    return !(document.body && document.body.dataset.gdConsentEnabled === 'true' && document.body.dataset.gdAnalyticsConsent !== 'true');
  }

  function trackCommerceEvent(name, detail) {
    if (!analyticsAllowed()) return;
    var eventName = name.indexOf('gd_') === 0 ? name : 'gd_' + name;
    var payload = Object.assign({ event: eventName }, detail || {});
    document.dispatchEvent(new CustomEvent('gd:analytics', { detail: payload }));
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish(eventName, detail || {}); } catch (error) { /* Keep storefront actions independent from analytics. */ }
    }
  }

  function initCommerceAnalytics() {
    if (document.documentElement.dataset.gdAnalyticsBound) return;
    document.documentElement.dataset.gdAnalyticsBound = 'true';
    /* Page views are published by Shopify's native pixel/customer events. */
    if (document.body && document.body.dataset.gdConsentEnabled === 'true') {
      document.addEventListener('gd:consent:updated', function (event) {
        if (!event.detail || !event.detail.consent || event.detail.consent.analytics !== true) return;
        trackCommerceEvent('gd_consent_granted', { page_path: window.location.pathname + window.location.search });
      });
    }
    var product = document.querySelector('[data-gd-product-root]');
    /* view/search/filter are not action success signals; Shopify owns page events. */
    /* Only successful mutations publish custom commerce events below. */
  }

  function money(cents, currency) {
    var drawer = document.querySelector('[data-gd-cart-drawer]');
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && drawer && drawer.dataset.gdMoneyFormat) {
      try { return window.Shopify.formatMoney(cents, drawer.dataset.gdMoneyFormat); } catch (error) { /* Use locale fallback. */ }
    }
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency || 'BRL' }).format(cents / 100); }
    catch (error) { return (cents / 100).toFixed(2).replace('.', ','); }
  }

  function showToast(message, variant) {
    var stack = document.querySelector('[data-gd-toast-stack]');
    if (!stack) return;
    var existing = toastEntries.find(function (entry) { return entry.message === message && entry.variant === variant; });
    if (existing) {
      if (variant !== 'shipping') {
        existing.count += 1;
        existing.countNode.textContent = existing.count + 'x';
        existing.countNode.setAttribute('aria-label', existing.count + ' vez' + (existing.count === 1 ? '' : 'es'));
      }
      window.clearTimeout(existing.timer);
      existing.timer = window.setTimeout(function () { removeToastEntry(existing); }, 3600);
      return;
    }

    var toast = document.createElement('div');
    toast.className = 'gd-toast is-visible' + (variant === 'shipping' ? ' gd-toast--shipping' : '');
    toast.setAttribute('role', 'status');
    var countNode = document.createElement('span');
    countNode.className = 'gd-toast__count';
    countNode.textContent = variant === 'shipping' ? '✓' : '1x';
    if (variant === 'shipping') countNode.setAttribute('aria-hidden', 'true');
    else countNode.setAttribute('aria-label', '1 vez');
    var messageNode = document.createElement('span');
    messageNode.className = 'gd-toast__message';
    messageNode.textContent = message;
    toast.appendChild(countNode);
    toast.appendChild(messageNode);
    if (String(message).toLocaleLowerCase('pt-BR').includes('carrinho')) {
      var cartButton = document.createElement('button');
      cartButton.type = 'button';
      cartButton.className = 'gd-toast__cart';
      cartButton.textContent = 'Abrir carrinho';
      cartButton.addEventListener('click', function () {
        removeToastEntry(entry);
        if (document.body && document.body.dataset.gdQuickCartEnabled === 'false') window.location.href = rootUrl + 'cart';
        else openDrawer(cartButton);
      });
      toast.appendChild(cartButton);
    }
    stack.appendChild(toast);
    var entry = {
      message: message,
      variant: variant,
      count: 1,
      node: toast,
      countNode: countNode,
      timer: window.setTimeout(function () { removeToastEntry(entry); }, 3600)
    };
    toastEntries.push(entry);
  }

  function removeToastEntry(entry) {
    window.clearTimeout(entry.timer);
    toastEntries = toastEntries.filter(function (item) { return item !== entry; });
    entry.node.classList.remove('is-visible');
    window.setTimeout(function () {
      if (entry.node.parentNode) entry.node.parentNode.removeChild(entry.node);
    }, 220);
  }

  function request(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) return response.json().catch(function () { return {}; }).then(function (data) {
        throw new Error(data.description || data.message || 'Não foi possível concluir a solicitação.');
      });
      return response.json();
    });
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-gd-cart-count]').forEach(function (node) { node.textContent = count; });
  }

  var favoritesStorageKey = 'gd:favorites';

  function readFavorites() {
    try {
      var stored = window.localStorage.getItem(favoritesStorageKey);
      var parsed = stored ? JSON.parse(stored) : [];
      if (!Array.isArray(parsed)) return [];
      return parsed.map(function (item) {
        if (typeof item === 'string') return { id: item };
        return item && typeof item.id === 'string' ? item : null;
      }).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function updateFavoriteCount(favorites) {
    var count = favorites.length;
    document.querySelectorAll('[data-gd-favorite-count]').forEach(function (node) {
      node.textContent = count;
      node.hidden = count === 0 && Boolean(node.closest('.gd-header'));
    });
  }

  function setFavoriteButton(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    var product = button.closest('[data-gd-product-card], [data-gd-product-root]');
    var productTitle = product ? product.dataset.gdProductTitle : '';
    button.setAttribute('aria-label', (active ? 'Remover ' : 'Favoritar ') + productTitle);
    var label = button.querySelector('span');
    if (label && button.hasAttribute('data-gd-product-favorite')) label.textContent = active ? 'Favoritado' : 'Favoritar';
  }

  function favoriteSnapshotFromCard(card) {
    return {
      id: String(card.dataset.gdProductId || ''),
      handle: card.dataset.gdProductHandle || '',
      title: card.dataset.gdProductTitle || 'Produto',
      category: card.dataset.gdProductCategory || 'Cuidado capilar',
      url: card.dataset.gdProductUrl || '#',
      image: card.dataset.gdProductImage || '',
      variantId: card.dataset.gdProductVariantId || '',
      price: Number(card.dataset.gdProductPrice) || 0,
      comparePrice: Number(card.dataset.gdProductComparePrice) || 0,
      available: card.dataset.gdProductAvailable !== 'false'
    };
  }

  function favoriteSnapshotFromRoot(root) {
    return {
      id: String(root.dataset.gdProductId || ''),
      handle: root.dataset.gdProductHandle || '',
      title: root.dataset.gdProductTitle || 'Produto',
      category: root.dataset.gdProductType || 'Cuidado capilar',
      url: root.dataset.gdProductUrl || '#',
      image: root.dataset.gdProductImage || '',
      variantId: root.dataset.gdProductVariantId || '',
      price: Number(root.dataset.gdProductPrice) || 0,
      comparePrice: Number(root.dataset.gdProductComparePrice) || 0,
      available: root.dataset.gdProductAvailable !== 'false'
    };
  }

  function writeFavorites(favorites, message) {
    try {
      window.localStorage.setItem(favoritesStorageKey, JSON.stringify(favorites));
    } catch (error) {
      showToast('Não foi possível salvar seus favoritos neste navegador.');
      return;
    }
    updateFavoriteCount(favorites);
    syncFavoriteCards(document);
    document.dispatchEvent(new CustomEvent('gd:favorites:updated', { detail: { favorites: favorites } }));
    if (message) showToast(message);
  }

  function bindFavoriteButton(button) {
    if (!button || button.dataset.gdBound) return;
    button.dataset.gdBound = 'true';
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var card = button.closest('[data-gd-product-card]');
      var root = button.closest('[data-gd-product-root]');
      var product = card || root;
      if (!product || !product.dataset.gdProductId) return;
      var favorites = readFavorites();
      var active = favorites.some(function (item) { return String(item.id) === String(product.dataset.gdProductId); });
      var next = active
        ? favorites.filter(function (item) { return String(item.id) !== String(product.dataset.gdProductId); })
        : favorites.concat(card ? favoriteSnapshotFromCard(card) : favoriteSnapshotFromRoot(root));
      writeFavorites(next, active ? 'Removido dos favoritos' : 'Adicionado aos favoritos');
    });
  }

  function syncFavoriteCards(scope) {
    var favorites = readFavorites();
    updateFavoriteCount(favorites);
    (scope || document).querySelectorAll('[data-gd-product-card] [data-gd-favorite], [data-gd-product-root] [data-gd-product-favorite]').forEach(function (button) {
      var product = button.closest('[data-gd-product-card], [data-gd-product-root]');
      var active = product && favorites.some(function (item) { return String(item.id) === String(product.dataset.gdProductId); });
      setFavoriteButton(button, active);
      bindFavoriteButton(button);
    });
    syncFavoriteProductLists(scope || document);
  }

  /* Favorites reorder only direct list children; the baseline restores server order. */
  var favoriteProductListSelectors = [
    '[data-gd-collection-results] .gd-product-grid',
    '.gd-search-page .gd-product-grid',
    '.gd-featured-products__track',
    '[data-gd-best-sellers-track]',
    '.gd-product-line__track',
    '.gd-category-best-sellers__track',
    '[data-gd-recommendations] .gd-product-grid',
    '[data-gd-campaign-product-grid]',
    '[data-gd-recent-grid]',
    '[data-gd-favorites-grid]',
    '.gd-lookbook__products',
    '.gd-social-videos__track',
    '.gd-social-videos__dots'
  ];

  function directProductNode(child) {
    if (!child || child.nodeType !== 1) return null;
    if (child.matches('[data-gd-product-card], [data-gd-recent-card], [data-gd-lookbook-product], [data-gd-social-video-product], [data-gd-social-video-dot-product]')) return child;
    for (var index = 0; index < child.children.length; index += 1) {
      var nested = child.children[index];
      if (nested.matches('[data-gd-product-card], [data-gd-recent-card], [data-gd-lookbook-product], [data-gd-social-video-product], [data-gd-social-video-dot-product]')) return nested;
    }
    return null;
  }

  function favoriteProductListContainers(scope) {
    var root = scope || document;
    var containers = [];
    favoriteProductListSelectors.forEach(function (selector) {
      if (root.matches && root.matches(selector)) containers.push(root);
      root.querySelectorAll(selector).forEach(function (container) {
        if (containers.indexOf(container) === -1) containers.push(container);
      });
    });
    if (
      root.matches
      && root.matches('.gd-product-grid--collection, .gd-featured-products__track, [data-gd-best-sellers-track], .gd-product-line__track, .gd-category-best-sellers__track, [data-gd-recommendations] .gd-product-grid, [data-gd-campaign-product-grid], [data-gd-recent-grid], [data-gd-favorites-grid], .gd-lookbook__products, .gd-social-videos__track, .gd-social-videos__dots')
      && containers.indexOf(root) === -1
    ) {
      containers.push(root);
    }
    return containers;
  }

  function syncFavoriteProductLists(scope) {
    var favorites = readFavorites();
    var favoriteIds = {};
    favorites.forEach(function (item) { favoriteIds[String(item.id)] = true; });

    favoriteProductListContainers(scope).forEach(function (container) {
      sortFavoriteProductList(container, favoriteIds);
    });
    if (typeof CustomEvent === 'function') {
      document.dispatchEvent(new CustomEvent('gd:favorites:reordered'));
    }
  }

  function sortFavoriteProductList(container, favoriteIds) {
    var children = Array.prototype.slice.call(container.children);
    var entries = [];
    children.forEach(function (child, index) {
      var productNode = directProductNode(child);
      if (!productNode || !productNode.dataset.gdProductId) return;
      if (child.dataset.gdFavoriteOrder === undefined) child.dataset.gdFavoriteOrder = String(index);
      entries.push({
        node: child,
        productId: String(productNode.dataset.gdProductId),
        order: Number(child.dataset.gdFavoriteOrder)
      });
    });
    if (entries.length < 2) return;

    var sorted = entries.slice().sort(function (left, right) {
      var leftFavorite = Boolean(favoriteIds[left.productId]);
      var rightFavorite = Boolean(favoriteIds[right.productId]);
      if (leftFavorite !== rightFavorite) return leftFavorite ? -1 : 1;
      return left.order - right.order;
    });
    var hasChanged = sorted.some(function (entry, index) { return entry.node !== entries[index].node; });
    if (!hasChanged) return;

    var fragment = document.createDocumentFragment();
    sorted.forEach(function (entry) { fragment.appendChild(entry.node); });
    var firstNonProduct = children.find(function (child) { return !entries.some(function (entry) { return entry.node === child; }); });
    if (firstNonProduct) container.insertBefore(fragment, firstNonProduct);
    else container.appendChild(fragment);
  }

  window.__gdFavoriteOrdering = { syncList: sortFavoriteProductList };

  function parseProductPrice(value) {
    if (typeof value === 'number') return Math.round(value);
    var parsed = Number(String(value || '').replace(',', '.'));
    return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
  }

  function createFavoriteCard(item) {
    var card = document.createElement('article');
    card.className = 'gd-product-card' + (item.available === false ? ' is-unavailable' : '');
    card.setAttribute('data-gd-product-card', '');
    card.dataset.gdProductId = item.id;
    card.dataset.gdProductHandle = item.handle || '';
    card.dataset.gdProductTitle = item.title;
    card.dataset.gdProductCategory = item.category || 'Cuidado capilar';
    card.dataset.gdProductUrl = item.url || '#';
    card.dataset.gdProductImage = item.image || '';
    card.dataset.gdProductVariantId = item.variantId || '';
    card.dataset.gdProductPrice = String(item.price || 0);
    card.dataset.gdProductComparePrice = String(item.comparePrice || 0);
    card.dataset.gdProductAvailable = String(item.available !== false);

    var mediaLink = document.createElement('a');
    mediaLink.className = 'gd-product-card__media';
    mediaLink.href = item.url || '#';
    mediaLink.setAttribute('aria-label', 'Ver ' + item.title);
    var media = document.createElement('div');
    media.className = 'gd-card__media';
    if (item.image) {
      var image = document.createElement('img');
      image.className = 'gd-card__img';
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      media.appendChild(image);
    } else {
      var placeholder = document.createElement('div');
      placeholder.className = 'gd-placeholder';
      media.appendChild(placeholder);
    }
    mediaLink.appendChild(media);
    card.appendChild(mediaLink);

    var favorite = document.createElement('button');
    favorite.className = 'gd-product-card__favorite is-active';
    favorite.type = 'button';
    favorite.setAttribute('data-gd-favorite', '');
    favorite.setAttribute('aria-pressed', 'true');
    favorite.setAttribute('aria-label', 'Remover ' + item.title + ' dos favoritos');
    var heart = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    heart.setAttribute('viewBox', '0 0 24 24');
    heart.setAttribute('aria-hidden', 'true');
    heart.setAttribute('fill', 'currentColor');
    var heartPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    heartPath.setAttribute('d', 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z');
    heart.appendChild(heartPath);
    favorite.appendChild(heart);
    card.appendChild(favorite);

    var body = document.createElement('div');
    body.className = 'gd-product-card__body';
    var eyebrow = document.createElement('p');
    eyebrow.className = 'gd-product-card__eyebrow';
    eyebrow.textContent = item.category || 'Cuidado capilar';
    body.appendChild(eyebrow);
    var heading = document.createElement('h3');
    heading.className = 'gd-product-card__title';
    var title = document.createElement('a');
    title.href = item.url || '#';
    title.textContent = item.title;
    heading.appendChild(title);
    body.appendChild(heading);

    var price = document.createElement('div');
    price.className = 'gd-product-card__price';
    if (item.comparePrice > item.price) {
      var compare = document.createElement('s');
      compare.textContent = money(item.comparePrice);
      price.appendChild(compare);
    }
    var current = document.createElement('strong');
    current.textContent = item.available === false ? 'Indisponível' : money(item.price);
    price.appendChild(current);
    body.appendChild(price);

    if (item.available !== false && item.price) {
      var terms = document.createElement('div');
      terms.className = 'gd-product-card__terms';
      terms.textContent = '3x de ' + money(Math.round(Number(item.price) / 3));
      body.appendChild(terms);
    }

    if (item.available === false) {
      var unavailable = document.createElement('p');
      unavailable.className = 'gd-product-card__availability';
      unavailable.textContent = 'Este produto não está disponível no momento.';
      body.appendChild(unavailable);
    }

    var form = document.createElement('form');
    form.action = rootUrl + 'cart/add';
    form.method = 'post';
    form.setAttribute('data-gd-add-form', '');
    var variant = document.createElement('input');
    variant.type = 'hidden'; variant.name = 'id'; variant.value = item.variantId || '';
    var quantity = document.createElement('input');
    quantity.type = 'hidden'; quantity.name = 'quantity'; quantity.value = '1';
    var add = document.createElement('button');
    add.className = 'gd-button gd-button--yellow gd-button--full';
    add.type = 'submit';
    add.disabled = item.available === false || !item.variantId;
    var addDesktopLabel = document.createElement('span');
    addDesktopLabel.className = 'gd-card-quick-label--desktop';
    addDesktopLabel.textContent = item.available === false ? 'Indisponível' : 'Adicionar ao carrinho';
    var addMobileLabel = document.createElement('span');
    addMobileLabel.className = 'gd-card-quick-label--mobile';
    addMobileLabel.textContent = item.available === false ? 'Indisponível' : 'Adicionar';
    add.appendChild(addDesktopLabel);
    add.appendChild(addMobileLabel);
    form.appendChild(variant); form.appendChild(quantity); form.appendChild(add);
    body.appendChild(form);

    var remove = document.createElement('button');
    remove.className = 'gd-button gd-button--outline gd-button--full gd-product-card__remove';
    remove.type = 'button';
    var removeIcon = heart.cloneNode(true);
    removeIcon.setAttribute('width', '16');
    removeIcon.setAttribute('height', '16');
    remove.appendChild(removeIcon);
    remove.appendChild(document.createTextNode('Remover dos favoritos'));
    remove.addEventListener('click', function () { favorite.click(); });
    body.appendChild(remove);
    card.appendChild(body);
    return card;
  }

  function hydrateFavorite(item) {
    if (!item.handle) return Promise.resolve(Object.assign({}, item, { available: false }));
    return request(rootUrl + 'products/' + encodeURIComponent(item.handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (product) {
        var variants = product.variants || [];
        var selected = variants.find(function (variant) { return String(variant.id) === String(item.variantId); });
        var availableVariant = selected && selected.available ? selected : variants.find(function (variant) { return variant.available; });
        return Object.assign({}, item, {
          title: product.title || item.title,
          url: product.url || (rootUrl + 'products/' + item.handle),
          image: product.featured_image || item.image,
          variantId: availableVariant ? String(availableVariant.id) : String(item.variantId || ''),
          price: availableVariant ? parseProductPrice(availableVariant.price) : item.price,
          comparePrice: availableVariant ? parseProductPrice(availableVariant.compare_at_price) : item.comparePrice,
          available: Boolean(availableVariant)
        });
      })
      .catch(function () { return Object.assign({}, item, { available: false }); });
  }

  function renderFavoritesPage(favorites) {
    var page = document.querySelector('[data-gd-favorites-page]');
    if (!page) return;
    var loading = page.querySelector('[data-gd-favorites-loading]');
    var empty = page.querySelector('[data-gd-favorites-empty]');
    var grid = page.querySelector('[data-gd-favorites-grid]');
    if (!grid || !empty || !loading) return;
    loading.hidden = true;
    grid.textContent = '';
    empty.hidden = favorites.length > 0;
    grid.hidden = favorites.length === 0;
    favorites.forEach(function (item) { grid.appendChild(createFavoriteCard(item)); });
    syncFavoriteCards(grid);
    bindAddForms(grid);
  }

  function initFavorites() {
    var favorites = readFavorites();
    syncFavoriteCards(document);
    var page = document.querySelector('[data-gd-favorites-page]');
    if (page) {
      var loading = page.querySelector('[data-gd-favorites-loading]');
      if (loading) loading.hidden = false;
      Promise.all(favorites.map(hydrateFavorite)).then(renderFavoritesPage);
    }
    if (!document.documentElement.dataset.gdFavoritesEventBound) {
      document.documentElement.dataset.gdFavoritesEventBound = 'true';
      window.addEventListener('storage', function (event) {
        if (event.key !== favoritesStorageKey) return;
        var updated = readFavorites();
        syncFavoriteCards(document);
        renderFavoritesPage(updated);
      });
      document.addEventListener('gd:favorites:updated', function (event) {
        var updated = event.detail && event.detail.favorites ? event.detail.favorites : readFavorites();
        renderFavoritesPage(updated);
      });
    }
  }

  var mobileCartNudgeTimer = 0;
  var mobileCartNudgeEndTimer = 0;
  var mobileCartAddedTimer = 0;

  function scheduleMobileCartNudge() {
    var preview = document.querySelector('.gd-mobile-cart-preview[data-gd-mobile-cart-preview]');
    window.clearTimeout(mobileCartNudgeTimer);
    window.clearTimeout(mobileCartNudgeEndTimer);
    if (!preview) return;
    preview.classList.remove('is-idle-nudge');
    if (preview.hidden || document.documentElement.classList.contains('gd-drawer-open')) return;
    mobileCartNudgeTimer = window.setTimeout(function () {
      if (preview.hidden || document.documentElement.classList.contains('gd-drawer-open')) return;
      preview.classList.add('is-idle-nudge');
      mobileCartNudgeEndTimer = window.setTimeout(function () {
        preview.classList.remove('is-idle-nudge');
        scheduleMobileCartNudge();
      }, 3600);
    }, 12000);
  }

  function initMobileCartNudge() {
    if (document.documentElement.dataset.gdCartNudgeBound) return;
    document.documentElement.dataset.gdCartNudgeBound = 'true';
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (eventName) {
      window.addEventListener(eventName, scheduleMobileCartNudge, { passive: true });
    });
    scheduleMobileCartNudge();
  }

  function productPurchaseActionsPassed(rect) {
    return Boolean(rect && rect.height > 0 && rect.bottom <= 0);
  }

  function syncProductPurchaseVisibility() {
    var section = document.querySelector('[data-gd-product-root]');
    var preview = document.querySelector('.gd-mobile-cart-preview[data-gd-mobile-cart-preview]');
    var sticky = section && section.querySelector('[data-gd-sticky-buy]');
    var actions = section && (section.querySelector('[data-gd-primary-purchase-actions]') || section.querySelector('[data-gd-product-form]'));
    var enabled = document.body.dataset.gdMobileCartPreviewEnabled !== 'false' && !(window.Shopify && window.Shopify.designMode);
    var passed = enabled && actions && productPurchaseActionsPassed(actions.getBoundingClientRect());
    if (preview && preview.hasAttribute('data-gd-product-offer')) {
      preview.hidden = !passed || Boolean(document.querySelector('[data-gd-cart-page]'));
    }
    if (sticky) sticky.hidden = !passed || Boolean(preview && !preview.hidden);
  }

  function initProductPurchaseVisibility(section) {
    syncProductPurchaseVisibility();
    if (window.Shopify && window.Shopify.designMode) return;
    if (!document.documentElement.dataset.gdPurchaseVisibilityBound) {
      document.documentElement.dataset.gdPurchaseVisibilityBound = 'true';
      var queued = false;
      var schedule = function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () { queued = false; syncProductPurchaseVisibility(); });
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('pageshow', schedule);
    }
    var actions = section.querySelector('[data-gd-primary-purchase-actions]') || section.querySelector('[data-gd-product-form]');
    if (!actions || section.dataset.gdPurchaseVisibilityObserved) return;
    section.dataset.gdPurchaseVisibilityObserved = 'true';
    if (window.IntersectionObserver) {
      new IntersectionObserver(syncProductPurchaseVisibility, { threshold: [0, 1] }).observe(actions);
    }
    if (window.ResizeObserver) {
      new ResizeObserver(syncProductPurchaseVisibility).observe(actions);
    }
  }

  function updateMobileCartPreview(cart) {
    if (!cart) return;
    currentCartItemCount = Number(cart.item_count) || 0;
    syncShippingCardBadges(cart);
    var preview = document.querySelector('.gd-mobile-cart-preview[data-gd-mobile-cart-preview]');
    if (!preview) return;
    var count = Number(cart.item_count) || 0;
    preview.hidden = document.body.dataset.gdMobileCartPreviewEnabled === 'false' || (count === 0 && !preview.hasAttribute('data-gd-product-offer')) || Boolean(document.querySelector('[data-gd-cart-page]'));
    syncProductPurchaseVisibility();
    document.querySelectorAll('[data-gd-mobile-cart-count]').forEach(function (node) {
      node.textContent = count + (count === 1 ? ' item no carrinho' : ' itens no carrinho');
    });
    document.querySelectorAll('[data-gd-mobile-cart-total]').forEach(function (node) {
      node.textContent = money(cart.total_price, cart.currency);
    });
    scheduleMobileCartNudge();
  }

  function highlightMobileCartPreview() {
    var preview = document.querySelector('.gd-mobile-cart-preview[data-gd-mobile-cart-preview]');
    if (!preview || preview.hidden) return;
    window.clearTimeout(mobileCartAddedTimer);
    preview.classList.remove('is-idle-nudge', 'is-added-glow');
    void preview.offsetWidth;
    preview.classList.add('is-added-glow');
    mobileCartAddedTimer = window.setTimeout(function () {
      preview.classList.remove('is-added-glow');
    }, 1800);
  }

  function changeCart(line, quantity) {
    return gdCart.change(line, quantity);
  }

  function isCompleteCart(cart) {
    return cart && Array.isArray(cart.items) && Number.isFinite(cart.item_count) && Number.isFinite(cart.total_price);
  }

  function cartMutation(path, body) {
    return request(rootUrl + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({}, body, { sections: 'cart-drawer,main-cart' }))
    }).then(function (cart) {
      if (path === 'cart/add.js' || !isCompleteCart(cart)) return request(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
      return cart;
    }).then(publishCart);
  }

  function publishCart(cart) {
    if (!isCompleteCart(cart)) throw new Error('Não foi possível atualizar o carrinho.');
    setCartCount(cart.item_count);
    updateMobileCartPreview(cart);
    document.dispatchEvent(new CustomEvent('gd:cart:updated', { detail: { cart: cart } }));
    return cart;
  }

  function queueCartWrite(operation) {
    var queued = cartAddQueue.then(operation, operation);
    cartAddQueue = queued.then(function () {}, function () {});
    return queued;
  }

  function addItemsToCart(items) {
    return gdCart.add(items);
  }

  function updateCart(values) { return gdCart.update(values); }

  var gdCart = {
    add: function (items, options) {
      var add = function () {
        var currentCart = currentCartItemCount === null || (options && typeof options.beforeAdd === 'function')
          ? request(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
          : Promise.resolve(null);
        return currentCart.then(function (cart) {
          if (options && typeof options.beforeAdd === 'function') options.beforeAdd(cart);
          if (cart && isCompleteCart(cart)) {
            currentCartItemCount = Number(cart.item_count) || 0;
            setCartCount(currentCartItemCount);
            updateMobileCartPreview(cart);
            if (shippingToastUnlocked === null) {
              notifyShippingUnlocked(cart, document.querySelector('[data-gd-progress-config] [data-gd-commercial-progress], [data-gd-commercial-progress]'));
            }
          }
          var wasEmpty = currentCartItemCount === 0;
          return cartMutation('cart/add.js', { items: items }).then(function (updated) {
            updated.gdWasEmptyBeforeAdd = wasEmpty;
            document.dispatchEvent(new CustomEvent('gd:cart:added', {
              detail: { cart: updated, items: items, source: options && options.source || 'storefront' }
            }));
            return updated;
          });
        });
      };
      return queueCartWrite(add);
    },
    change: function (line, quantity) { return queueCartWrite(function () { return cartMutation('cart/change.js', { id: line, quantity: quantity }); }); },
    update: function (updates) { return queueCartWrite(function () { return cartMutation('cart/update.js', updates); }); },
    transaction: function (operation) {
      return queueCartWrite(function () {
        return operation({
          get: function () { return request(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }); },
          post: function (path, body) {
            return request(rootUrl + path, {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body)
            });
          },
          commit: publishCart
        });
      });
    }
  };

  function isManagedRewardGift(item) {
    return Boolean(item && item.properties && item.properties._gd_reward_gift === 'true');
  }

  function rewardSubtotal(cart) {
    return (cart.items || []).reduce(function (total, item) {
      if (isManagedRewardGift(item) || (item.properties && item.properties._gota_brinde === 'true')) return total;
      return total + Number(item.final_line_price != null ? item.final_line_price : (item.line_price || 0));
    }, 0);
  }

  function commercialGoals(cart, source) {
    if (!source) return { goals: [], subtotal: 0 };
    var goals = [];
    var ordinal = 0;
    var subtotal = rewardSubtotal(cart);
    var shipping = Number(source.dataset.gdShippingThreshold) || 0;
    if (source.dataset.gdShippingActive === 'true' && shipping > 0) {
      goals.push({ amount: shipping, name: 'frete grátis', kind: 'shipping', ordinal: ordinal++ });
    }
    var discountNodes = source.querySelectorAll ? source.querySelectorAll('[data-gd-discount-tier]') : [];
    Array.prototype.forEach.call(discountNodes, function (node) {
      var amount = Number(node.dataset.gdThreshold) || 0;
      var percent = Number(node.dataset.gdPercent) || 0;
      var label = node.dataset.gdLabel || '';
      if (node.dataset.gdEnabled === 'true' && amount > 0 && (percent > 0 || label)) {
        goals.push({ amount: amount, name: label || percent + '% de desconto', kind: 'discount', percent: percent, ordinal: ordinal++ });
      }
    });
    var giftNodes = source.querySelectorAll ? source.querySelectorAll('[data-gd-gift-tier]') : [];
    Array.prototype.forEach.call(giftNodes, function (node) {
      var amount = Number(node.dataset.gdThreshold) || 0;
      var label = node.dataset.gdLabel || node.dataset.gdProductTitle || '';
      if (node.dataset.gdEnabled === 'true' && amount > 0 && label) {
        goals.push({
          amount: amount,
          name: label,
          kind: 'gift',
          tier: Number(node.dataset.gdGiftTier || 0),
          productId: node.dataset.gdProductId || '',
          variantId: node.dataset.gdVariantId || '',
          productTitle: node.dataset.gdProductTitle || label,
          ordinal: ordinal++
        });
      }
    });
    [['gdGiftOneThreshold', 'gdGiftOneName', 1], ['gdGiftTwoThreshold', 'gdGiftTwoName', 2]].forEach(function (keys) {
      var amount = Number(source.dataset[keys[0]]) || 0;
      var name = source.dataset[keys[1]] || '';
      if (amount > 0 && name && !goals.some(function (goal) { return goal.kind === 'gift' && goal.amount === amount && goal.name === name; })) {
        goals.push({ amount: amount, name: name, kind: 'gift', tier: keys[2], claimable: false, ordinal: ordinal++ });
      }
    });
    goals.sort(function (a, b) { return a.amount - b.amount || a.ordinal - b.ordinal; });
    return { goals: goals, subtotal: subtotal };
  }

  function commercialGoal(cart, source) {
    var state = commercialGoals(cart, source);
    return state.goals.find(function (goal) { return goal.amount > state.subtotal; }) || state.goals[state.goals.length - 1] || null;
  }

  function highestUnlockedGift(cart, source) {
    var state = commercialGoals(cart, source);
    var gifts = state.goals.filter(function (goal) { return goal.kind === 'gift' && goal.amount <= state.subtotal; });
    return gifts[gifts.length - 1] || null;
  }

  function reconcileManagedGifts(cart, source) {
    if (!source) return Promise.resolve(cart);
    var highest = highestUnlockedGift(cart, source);
    var managed = (cart.items || []).filter(isManagedRewardGift);
    var removals = managed.filter(function (item) {
      var managedTier = Number(item.properties && item.properties._gd_reward_tier || 0);
      return !highest || Number(item.quantity) !== 1 || (managedTier > 0 && managedTier > Number(highest.tier || 0)) || Number(item.final_line_price || item.line_price || 0) < 0;
    });
    if (!removals.length) return Promise.resolve(cart);
    return removals.reduce(function (promise, item) {
      return promise.then(function (current) { return changeCart(item.key, 0); });
    }, Promise.resolve(cart));
  }

  function claimRewardGift(goal, trigger) {
    if (!goal || goal.kind !== 'gift' || !goal.variantId) return Promise.resolve();
    var source = document.querySelector('[data-gd-progress-config] [data-gd-commercial-progress], [data-gd-commercial-progress]');
    return request(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (cart) {
      var existing = (cart.items || []).filter(isManagedRewardGift);
      var same = existing.find(function (item) { return Number(item.properties && item.properties._gd_reward_tier) === Number(goal.tier); });
      var remove = existing.filter(function (item) { return item !== same; });
      return remove.reduce(function (promise, item) {
        return promise.then(function () { return changeCart(item.key, 0); });
      }, Promise.resolve(cart)).then(function () {
        if (same) return request(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
      return gdCart.add([{ id: Number(goal.variantId), quantity: 1, properties: { _gd_reward_gift: 'true', _gd_reward_tier: String(goal.tier) } }]);
      });
    }).then(function (cart) {
      setCartCount(cart.item_count);
      updateMobileCartPreview(cart);
      if (trigger) trigger.disabled = false;
      var drawer = document.querySelector('[data-gd-cart-drawer].is-open');
      if (drawer) renderDrawerFast(cart);
      else if (document.querySelector('[data-gd-cart-page]') && window.location.reload) window.location.reload();
      return cart;
    }).catch(function (error) {
      if (trigger) trigger.disabled = false;
      showToast(error.message);
      throw error;
    });
  }

  function renderShippingProgress(cart, content) {
    var source = document.querySelector('[data-gd-progress-config] [data-gd-commercial-progress], [data-gd-commercial-progress]');
    var state = commercialGoals(cart, source);
    var cartTotal = Number(cart.total_price);
    if (cart.total_price != null && Number.isFinite(cartTotal)) {
      state.subtotal = Math.min(state.subtotal, Math.max(0, cartTotal));
    }
    var goal = state.goals.find(function (candidate) { return candidate.amount > state.subtotal; }) || state.goals[state.goals.length - 1] || null;
    if (!goal) {
      content.dataset.gdShippingUnlocked = 'false';
      return 0;
    }
    var unlocked = state.goals.filter(function (candidate) { return candidate.amount <= state.subtotal; });
    var shippingUnlocked = unlocked.some(function (candidate) { return candidate.kind === 'shipping'; });
    var hasShippingGoal = state.goals.some(function (candidate) { return candidate.kind === 'shipping'; });
    content.dataset.gdShippingUnlocked = shippingUnlocked ? 'true' : 'false';
    var remaining = Math.max(0, goal.amount - state.subtotal);
    var meterGoal = state.goals.find(function (candidate) { return candidate.kind === 'shipping'; }) || goal;
    var percent = Math.min(100, Math.max(0, Math.round((state.subtotal / meterGoal.amount) * 100)));
    var progress = document.createElement('section');
    progress.className = 'gd-shipping-progress'; progress.setAttribute('data-gd-commercial-progress', '');
    if (hasShippingGoal && !shippingUnlocked) progress.classList.add('gd-shipping-progress--pending');
    var message = document.createElement('p');
    var parts = unlocked.length ? ['Condições atingidas: ' + unlocked.map(function (item) {
      return item.kind === 'discount' && item.percent ? item.name + ' (' + item.percent + '%)' : item.name;
    }).join(', ') + '.'] : [];
    if (remaining > 0) {
      if (goal.kind === 'shipping') {
        parts.push((source.dataset.gdPreMessage || 'Faltam [valor] para a condição configurada.').replace(/\[valor\]/g, money(remaining, cart.currency)));
      } else {
        parts.push('Faltam ' + money(remaining, cart.currency) + ' para ' + goal.name + '.');
      }
    } else if (goal.kind === 'shipping') {
      parts.push(source.dataset.gdCompleteMessage || 'O subtotal atingiu a condição configurada.');
    }
    if (unlocked.some(function (item) { return item.kind === 'discount'; })) parts.push(source.dataset.gdDiscountCopy || 'Meta atingida; aplicação confirmada no checkout.');
    if (unlocked.some(function (item) { return item.kind === 'gift'; })) parts.push(source.dataset.gdGiftCopy || 'Meta atingida; adicione o item e confirme a gratuidade no checkout.');
    if (shippingUnlocked) {
      var shippingGoal = state.goals.find(function (candidate) { return candidate.kind === 'shipping'; });
      var threshold = shippingGoal.amount;
      var thresholdLabel = (cart.currency || 'BRL') === 'BRL'
        ? 'R$' + new Intl.NumberFormat('pt-BR', { minimumFractionDigits: threshold % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(threshold / 100)
        : money(threshold, cart.currency);
      message.textContent = 'Você atingiu a meta de ' + thresholdLabel + ' para o frete grátis';
    } else {
      message.textContent = parts.join(' ');
    }
    message.textContent = message.textContent.replace(/frete\s+gr[aá]tis/gi, 'FRETE GRÁTIS');
    if (shippingUnlocked) {
      var badge = document.createElement('strong');
      badge.className = 'gd-shipping-progress__badge';
      var badgeCheck = document.createElement('span');
      badgeCheck.setAttribute('aria-hidden', 'true');
      badgeCheck.textContent = '✓';
      badge.appendChild(badgeCheck);
      badge.appendChild(document.createTextNode('VOCÊ GANHOU FRETE GRÁTIS.'));
      progress.appendChild(badge);
    }
    progress.appendChild(message);
    if (hasShippingGoal) {
      var shippingNote = document.createElement('small');
      shippingNote.className = 'gd-shipping-progress__note';
      shippingNote.textContent = '* Sujeito ao CEP, aos itens e ao checkout.';
      progress.appendChild(shippingNote);
    }
    unlocked.filter(function (item) { return item.kind === 'gift' && item.claimable !== false; }).slice(-1).forEach(function (gift) {
      var button = document.createElement('button');
      button.type = 'button'; button.className = 'gd-button gd-button--outline gd-reward-gift-claim';
      button.textContent = 'Adicionar brinde: ' + gift.productTitle;
      button.addEventListener('click', function () { button.disabled = true; claimRewardGift(gift, button); });
      progress.appendChild(button);
    });
    if (!shippingUnlocked) {
      var meter = document.createElement('div');
      meter.className = 'gd-shipping-progress__meter';
      meter.setAttribute('role', 'progressbar');
      meter.setAttribute('aria-label', 'Progresso até ' + meterGoal.name);
      meter.setAttribute('aria-valuemin', '0'); meter.setAttribute('aria-valuemax', '100'); meter.setAttribute('aria-valuenow', String(percent));
      meter.setAttribute('aria-valuetext', money(state.subtotal, cart.currency) + ' de ' + money(meterGoal.amount, cart.currency));
      var fill = document.createElement('span'); fill.style.width = percent + '%'; meter.appendChild(fill);
      if (source && source.dataset.gdProgressBottleUrl) {
        var tonic = document.createElement('img');
        tonic.className = 'gd-shipping-progress__tonic';
        tonic.src = source.dataset.gdProgressBottleUrl;
        tonic.alt = '';
        tonic.setAttribute('aria-hidden', 'true');
        tonic.decoding = 'async';
        tonic.style.left = 'clamp(12px, ' + percent + '%, calc(100% - 12px))';
        meter.appendChild(tonic);
      }
      if (hasShippingGoal) {
        var scale = document.createElement('div');
        scale.className = 'gd-shipping-progress__scale';
        var target = document.createElement('span');
        target.className = 'gd-shipping-progress__target';
        target.textContent = 'Meta ' + ((cart.currency || 'BRL') === 'BRL'
          ? 'R$' + new Intl.NumberFormat('pt-BR', { minimumFractionDigits: meterGoal.amount % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(meterGoal.amount / 100)
          : money(meterGoal.amount, cart.currency));
        scale.appendChild(target);
        var current = document.createElement('strong');
        current.className = 'gd-shipping-progress__current';
        current.textContent = money(Number.isFinite(cartTotal) && cart.total_price != null ? Math.max(0, cartTotal) : state.subtotal, cart.currency);
        current.setAttribute('aria-label', 'Valor atual do carrinho: ' + current.textContent);
        current.style.left = 'clamp(48px, ' + percent + '%, calc(100% - 48px))';
        meter.appendChild(current);
        scale.appendChild(meter);
        progress.appendChild(scale);
      } else {
        progress.appendChild(meter);
      }
    }
    content.appendChild(progress);
    return remaining;
  }

  function notifyShippingUnlocked(cart, source) {
    var state = commercialGoals(cart, source);
    var goal = state.goals.find(function (candidate) { return candidate.kind === 'shipping'; });
    // Do not celebrate a cart discounted below the configured shipping goal.
    var unlocked = Boolean(goal && state.subtotal >= goal.amount && Number(cart.total_price) >= goal.amount);
    var justUnlocked = shippingToastUnlocked === false && unlocked;
    shippingToastUnlocked = unlocked;
    if (!unlocked) {
      window.clearTimeout(shippingToastTimer);
      toastEntries.filter(function (entry) { return entry.variant === 'shipping'; }).forEach(removeToastEntry);
    }
    if (!justUnlocked) return;
    window.clearTimeout(shippingToastTimer);
    // afterAdd may open the drawer in this promise chain; check after it settles.
    shippingToastTimer = window.setTimeout(function () {
      if (!shippingToastUnlocked || document.querySelector('[data-gd-cart-drawer].is-open')) return;
      if (cart.gdWasEmptyBeforeAdd) return;
      if (window.Shopify && window.Shopify.designMode) return;
      showToast('Você ganhou frete grátis!', 'shipping');
    }, 0);
  }

  function updateProductShippingProgress(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.total_price == null || !Number.isFinite(Number(cart.total_price))) return;
    var cartTotal = Math.max(0, Number(cart.total_price));
    var eligible = Math.max(0, Math.min(rewardSubtotal(cart), cartTotal));
    document.querySelectorAll('[data-gd-product-shipping]').forEach(function (panel) {
      var goal = Number(panel.dataset.gdGoal);
      if (!Number.isFinite(goal) || goal <= 0) return;
      var remaining = Math.max(0, goal - eligible);
      var percent = Math.min(100, Math.round(eligible / goal * 100));
      var message = panel.querySelector('[data-gd-product-shipping-message]');
      var meter = panel.querySelector('[data-gd-product-shipping-meter]');
      var fill = panel.querySelector('[data-gd-product-shipping-fill]');
      var total = panel.querySelector('[data-gd-product-shipping-total]');
      var goalLabel = panel.querySelector('[data-gd-product-shipping-goal]');
      panel.dataset.state = remaining === 0 ? 'complete' : 'pending';
      if (message) {
        message.textContent = remaining === 0 ? 'Você atingiu a meta de ' : 'Faltam ';
        if (remaining > 0) {
          var amount = document.createElement('strong');
          amount.setAttribute('data-gd-product-shipping-amount', '');
          amount.textContent = money(remaining, cart.currency);
          message.appendChild(amount);
          message.appendChild(document.createTextNode(' no seu carrinho para ganhar '));
        }
        var highlight = document.createElement('strong');
        highlight.textContent = remaining === 0 ? 'FRETE GRÁTIS!' : 'FRETE GRÁTIS.';
        message.appendChild(highlight);
      }
      if (meter) {
        meter.setAttribute('aria-valuenow', String(percent));
        meter.setAttribute('aria-valuetext', money(eligible, cart.currency) + ' de ' + money(goal, cart.currency));
      }
      if (fill) fill.style.width = percent + '%';
      if (total) total.textContent = 'Carrinho ' + money(cartTotal, cart.currency);
      if (goalLabel) goalLabel.textContent = 'Meta ' + money(goal, cart.currency);
    });
  }

  function updateCommercialProgress(cart) {
    updateProductShippingProgress(cart);
    var source = document.querySelector('[data-gd-progress-config] [data-gd-commercial-progress], [data-gd-commercial-progress]');
    notifyShippingUnlocked(cart, source);
    reconcileManagedGifts(cart, source).then(function (updated) {
      if (updated === cart) return;
      var drawer = document.querySelector('[data-gd-cart-drawer].is-open');
      if (drawer) renderDrawerFast(updated);
    });
    document.querySelectorAll('[data-gd-progress-slot]').forEach(function (slot) {
      slot.textContent = '';
      renderShippingProgress(cart, slot);
    });
    updateShippingCalculatorVisibility(cart);
  }

  function updateShippingCalculatorVisibility(cart) {
    if (!cart) return;
    var subtotal = rewardSubtotal(cart);
    if (window.GDShippingUI) return window.GDShippingUI.updateShells(cart, subtotal);
    document.querySelectorAll('[data-gd-shipping-shell]').forEach(function (shell) {
      var threshold = Number(shell.dataset.gdShippingThreshold || 0);
      var reached = shell.dataset.gdShippingActive === 'true' && threshold > 0 && subtotal >= threshold;
      shell.hidden = !Number(cart.item_count) || reached;
    });
  }

  function shippingRecommendationTier(goal, remaining) {
    if (!(goal > 0) || !(remaining > 0) || !Number.isFinite(goal) || !Number.isFinite(remaining)) return 0;
    if (remaining * 99 <= goal * 20) return 1;
    if (remaining * 99 <= goal * 50) return 2;
    return 3;
  }

  function renderThresholdRecommendation(cart, content) {
    var source = document.querySelector('[data-gd-progress-config] [data-gd-commercial-progress]');
    var state = commercialGoals(cart, source);
    var shippingGoal = state.goals.find(function (goal) { return goal.kind === 'shipping'; });
    var netTotal = cart.total_price == null ? state.subtotal : Number(cart.total_price);
    var subtotal = Number.isFinite(netTotal) ? Math.max(0, Math.min(state.subtotal, netTotal)) : state.subtotal;
    var remaining = shippingGoal ? Math.max(0, shippingGoal.amount - subtotal) : 0;
    var tier = remaining > 0 ? shippingRecommendationTier(shippingGoal.amount, remaining) : 1;
    var pool = document.querySelector('[data-gd-recommendation-tier="' + tier + '"]');
    // Respect the merchant's tier collection; native complements are only a legacy fallback.
    var nativeNodes = pool ? [] : Array.prototype.slice.call(document.querySelectorAll('[data-gd-native-recommendations-host] [data-gd-best-seller]'));
    var poolNodes = Array.prototype.slice.call(pool ? pool.querySelectorAll('[data-gd-best-seller]') : document.querySelectorAll('[data-gd-best-sellers] [data-gd-best-seller]'));
    var seen = Object.create(null);
    var allCandidates = nativeNodes.concat(poolNodes).filter(function (candidate) {
      var id = candidate.dataset.productId;
      if (!id || !candidate.dataset.variantId || candidate.dataset.available === 'false' || seen[id]) return false;
      if (cart.items.some(function (item) { return String(item.product_id) === String(id); })) return false;
      seen[id] = true;
      return true;
    });
    var candidates = allCandidates.map(function (candidate, index) { return { node: candidate, index: index }; }).sort(function (a, b) {
      if (remaining <= 0) return a.index - b.index;
      var aCloses = Number(a.node.dataset.price) >= remaining;
      var bCloses = Number(b.node.dataset.price) >= remaining;
      if (aCloses !== bCloses) return aCloses ? -1 : 1;
      return Math.abs(Number(a.node.dataset.price) - remaining) - Math.abs(Number(b.node.dataset.price) - remaining);
    }).map(function (entry) { return entry.node; }).slice(0, 5);
    if (!candidates.length) return;
    var section = document.createElement('section');
    section.className = 'gd-cart-drawer__threshold-suggestions gd-cart-rec';
    section.setAttribute('data-gd-cart-rec-carousel', '');
    var head = document.createElement('div');
    head.className = 'gd-cart-rec__head';
    var heading = document.createElement('h3');
    heading.textContent = 'Experimente levar também';
    head.appendChild(heading);
    if (candidates.length > 1) {
      var arrows = document.createElement('div');
      arrows.className = 'gd-cart-rec__arrows';
      [['prev', 'Anterior', 'm15 18-6-6 6-6'], ['next', 'Próximo', 'm9 18 6-6-6-6']].forEach(function (cfg) {
        var arrowButton = document.createElement('button');
        arrowButton.type = 'button';
        arrowButton.className = 'gd-cart-rec__arrow';
        arrowButton.setAttribute('data-gd-cart-rec-' + cfg[0], '');
        arrowButton.setAttribute('aria-label', cfg[1] + ' sugestão');
        arrowButton.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="' + cfg[2] + '"/></svg>';
        arrows.appendChild(arrowButton);
      });
      head.appendChild(arrows);
    }
    section.appendChild(head);
    var rail = document.createElement('div');
    rail.className = 'gd-cart-rec__rail';
    rail.setAttribute('data-gd-cart-rec-rail', '');
    rail.setAttribute('role', 'list');
    section.appendChild(rail);
    candidates.forEach(function (candidate) {
    var card = document.createElement('article');
    card.setAttribute('role', 'listitem');
    card.className = 'gd-cart-drawer__threshold-recommendation';
     if (candidate.dataset.image) {
      var image = document.createElement('img');
      image.src = candidate.dataset.image;
      image.alt = candidate.dataset.title;
      image.loading = 'lazy';
      card.appendChild(image);
     } else {
       var imagePlaceholder = document.createElement('span');
       imagePlaceholder.className = 'gd-cart-drawer__threshold-recommendation-image-placeholder';
       imagePlaceholder.setAttribute('aria-hidden', 'true');
       card.appendChild(imagePlaceholder);
    }
    var details = document.createElement('div');
    var title = document.createElement('a');
    title.href = candidate.dataset.url;
    title.textContent = candidate.dataset.title;
    details.appendChild(title);
    if (candidate.dataset.variantTitle && candidate.dataset.variantTitle !== 'Default Title') {
      var variant = document.createElement('small');
      variant.textContent = candidate.dataset.variantTitle;
      details.appendChild(variant);
    }
    var price = document.createElement('strong');
    price.textContent = money(Number(candidate.dataset.price), cart.currency);
    details.appendChild(price);
    var button = document.createElement('button');
    button.type = 'button'; button.className = 'gd-button gd-button--outline gd-cart-rec__add'; button.textContent = '+ Adicionar';
    button.setAttribute('aria-label', 'Adicionar ' + candidate.dataset.title + ' ao carrinho');
    button.addEventListener('click', function () {
      if (button.disabled) return;
      var variantId = Number(candidate.dataset.variantId);
      if (!variantId) { showToast('Este produto não está disponível no momento.'); return; }
      button.disabled = true;
      button.textContent = 'Adicionando…';
      gdCart.add([{ id: variantId, quantity: 1 }])
        .then(function (updatedCart) {
          trackCommerceEvent('gd_add_to_cart', { source: 'cart_recommendation' });
          showToast('Produto adicionado ao carrinho.');
          return renderDrawerFast(updatedCart);
        })
        .catch(function (error) { showToast(error.message); })
        .finally(function () {
          button.disabled = false;
          button.textContent = '+ Adicionar';
        });
    });
    details.appendChild(button);
    card.appendChild(details);
    rail.appendChild(card);
    });
    content.appendChild(section);
  }

  function hydrateCartComparePrices(cart) {
    return Promise.all((cart.items || []).map(function (item) {
      if (!item.handle) return Promise.resolve();
      var key = item.handle;
      var cached = cartProductRequests[key];
      if (!cached || Date.now() - cached.created > 60000) {
        cached = { created: Date.now() };
        cached.promise = request(rootUrl + 'products/' + encodeURIComponent(key) + '.js', { headers: { Accept: 'application/json' } })
          .catch(function (error) {
            if (cartProductRequests[key] === cached) delete cartProductRequests[key];
            throw error;
          });
        cartProductRequests[key] = cached;
      }
      return cached.promise
        .then(function (product) {
          var variant = (product.variants || []).find(function (candidate) {
            return String(candidate.id) === String(item.variant_id);
          });
          item.gd_compare_at_price = variant ? parseProductPrice(variant.compare_at_price) : 0;
        })
        .catch(function () { item.gd_compare_at_price = 0; });
    })).then(function () { return cart; });
  }

  function refreshDrawerSavings(cart) {
    var footer = document.querySelector('[data-gd-cart-footer] .gd-cart-drawer__footer');
    if (!footer) return;
    var originalTotal = cart.items.reduce(function (total, item) {
      return total + Math.max(Number(item.original_line_price || 0), Number(item.gd_compare_at_price || 0) * Number(item.quantity || 0), Number(item.final_line_price || 0));
    }, 0);
    var savings = Math.max(0, originalTotal - Number(cart.original_total_price || cart.total_price || 0)) + Math.max(0, Number(cart.total_discount || 0));
    var subtotal = footer.querySelector('.gd-cart-drawer__subtotal-values');
    var original = subtotal && subtotal.querySelector('small');
    var saved = footer.querySelector('.gd-cart-drawer__savings');
    if (savings <= 0) {
      if (original) original.remove();
      if (saved) saved.remove();
      return;
    }
    if (subtotal) {
      if (!original) {
        original = document.createElement('small');
        subtotal.insertBefore(original, subtotal.firstChild);
      }
      original.textContent = 'De ';
      var crossed = document.createElement('s');
      crossed.textContent = money(originalTotal, cart.currency);
      crossed.dataset.gdDrawerOriginalTotal = '';
      crossed.dataset.gdBaseTotal = String(originalTotal);
      original.appendChild(crossed);
      original.appendChild(document.createTextNode(' por'));
    }
    if (!saved) {
      saved = document.createElement('p');
      saved.className = 'gd-cart-drawer__savings';
      var label = document.createElement('span');
      label.textContent = 'Total economizado';
      saved.appendChild(label);
      saved.appendChild(document.createElement('strong'));
      footer.insertBefore(saved, footer.querySelector('.gd-cart-drawer__checkout'));
    }
    saved.querySelector('strong').textContent = money(savings, cart.currency);
  }

  function createCartCountdown() {
    var box = document.createElement('div');
    box.className = 'gd-cart-countdown';
    box.setAttribute('data-gd-cart-countdown', '');
    var timerConfig = document.querySelector('[data-gd-cart-timer-config]');
    var minutes = Math.max(1, Math.min(60, Math.round(Number(timerConfig && timerConfig.dataset.minutes) || 10)));
    box.dataset.gdDurationSeconds = String(minutes * 60);
    box.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2 2M9 2h6"/></svg><span class="gd-cart-countdown__text"><span data-gd-cart-countdown-label>Seu carrinho está reservado por</span></span><strong class="gd-cart-countdown__value" data-gd-cart-countdown-value>' + String(minutes).padStart(2, '0') + ':00</strong>';
    return box;
  }

  function createCartTrustRow() {
    var row = document.createElement('ul');
    row.className = 'gd-cart-trust';
    [['Pagamento seguro', '<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>'],
      ['Frete rápido', '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>'],
      ['Cliente satisfeito', '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l8.8 8.8 8.8-8.8a5.5 5.5 0 0 0 0-7.8z"/>']].forEach(function (entry) {
      var li = document.createElement('li');
      li.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' + entry[1] + '</svg>';
      li.appendChild(document.createTextNode(entry[0]));
      row.appendChild(li);
    });
    return row;
  }

  function renderDrawerFast(cart) {
    renderDrawer(cart);
    var version = drawerRenderVersion;
    // Optional requests must never hold up products, totals or checkout.
    hydrateCartComparePrices(cart).then(function () {
      if (version === drawerRenderVersion) refreshDrawerSavings(cart);
    });
    loadNativeComplements(cart).then(function () {
      if (version !== drawerRenderVersion) return;
      var content = document.querySelector('[data-gd-cart-content]');
      if (!content || !cart.items.length) return;
      var previous = content.querySelector('.gd-cart-drawer__threshold-suggestions');
      var temporary = document.createElement('div');
      renderThresholdRecommendation(cart, temporary);
      var replacement = temporary.firstElementChild;
      if (previous && replacement) previous.replaceWith(replacement);
      else if (previous) previous.remove();
      else if (replacement) content.appendChild(replacement);
    });
    return cart;
  }

  function renderDrawer(cart) {
    drawerRenderVersion += 1;
    var content = document.querySelector('[data-gd-cart-content]');
    if (!content) return;
    content.textContent = '';
    document.querySelectorAll('[data-gd-cart-title-count]').forEach(function (node) {
      node.textContent = String(cart.item_count);
      node.setAttribute('aria-label', cart.item_count + (Number(cart.item_count) === 1 ? ' item' : ' itens'));
    });
    var summary = document.querySelector('[data-gd-cart-summary]');
    var footerHost = summary && summary.querySelector('[data-gd-cart-footer]');
    var auxiliary = document.querySelector('[data-gd-cart-auxiliary]');
    var couponHost = auxiliary && auxiliary.querySelector('[data-gd-cart-coupon-host]');
    if (summary) summary.hidden = !cart.items.length;
    if (auxiliary) auxiliary.hidden = !cart.items.length;
    if (footerHost) footerHost.textContent = '';
    if (couponHost) couponHost.textContent = '';
    updateShippingCalculatorVisibility(cart);
    var remaining = 0;
    if (cart.items.length) {
      content.appendChild(createCartCountdown());
      remaining = renderShippingProgress(cart, content);
    }
    if (!cart.items.length) {
      var empty = document.createElement('div');
      empty.className = 'gd-cart-drawer__empty';
      empty.innerHTML = '<h3>Seu carrinho está vazio</h3><p>Comece escolhendo um produto para a sua rotina.</p>';
      var grid = document.createElement('div');
      grid.className = 'gd-cart-drawer__empty-products';
      Array.prototype.slice.call(document.querySelectorAll('[data-gd-best-seller]'), 0, 3).forEach(function (item) {
        var card = document.createElement('article');
        card.className = 'gd-cart-drawer__empty-product';
        if (item.dataset.image) {
          var image = document.createElement('img');
          image.src = item.dataset.image;
          image.alt = item.dataset.title || '';
          image.loading = 'lazy';
          card.appendChild(image);
        }
        var details = document.createElement('div');
        var title = document.createElement('strong');
        title.textContent = item.dataset.title || 'Produto Gota Dourada';
        var price = document.createElement('small');
        price.textContent = money(Number(item.dataset.price || 0), cart.currency);
        details.appendChild(title);
        details.appendChild(price);
        card.appendChild(details);
        var form = document.createElement('form');
        form.dataset.gdAddForm = '';
        form.innerHTML = '<input type="hidden" name="id" value="' + (item.dataset.variantId || '') + '"><input type="hidden" name="quantity" value="1"><button class="gd-button gd-button--yellow" type="submit">Adicionar ao carrinho</button>';
        card.appendChild(form);
        grid.appendChild(card);
      });
      empty.appendChild(grid);
      content.appendChild(empty);
      bindAddForms(empty);
      return;
    }
    var list = document.createElement('div');
    list.className = 'gd-cart-drawer__items';
    cart.items.forEach(function (item) {
      var article = document.createElement('article');
      article.className = 'gd-cart-drawer__item';
      if (item.image) {
        var image = document.createElement('img');
        image.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        image.alt = item.product_title;
        image.loading = 'lazy';
        article.appendChild(image);
      }
      var body = document.createElement('div');
      var title = document.createElement('a');
      title.href = item.url;
      title.textContent = item.product_title;
      body.appendChild(title);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variant = document.createElement('small');
        variant.textContent = item.variant_title;
        body.appendChild(variant);
      }
      var linePrice = document.createElement('strong');
      linePrice.textContent = money(item.final_line_price, cart.currency);
      if (isManagedRewardGift(item)) {
        var giftLabel = document.createElement('small');
        giftLabel.className = 'gd-cart-drawer__gift-label';
        var giftIsFree = item.final_line_price === 0 || Number(item.final_line_price || 0) === 0;
        giftLabel.textContent = giftIsFree
          ? 'Brinde promocional · confirmado/grátis'
          : 'Brinde promocional · condição ainda não aplicada no checkout';
        body.appendChild(giftLabel);
      }
      var actions = document.createElement('div');
      actions.className = 'gd-cart-drawer__line-actions';
      actions.appendChild(linePrice);
      if (isManagedRewardGift(item)) {
        var removeGift = document.createElement('button');
        removeGift.type = 'button';
        removeGift.className = 'gd-text-link';
        removeGift.textContent = 'Remover brinde';
        removeGift.addEventListener('click', function () {
          removeGift.disabled = true;
          changeCart(item.key, 0).then(function (updated) {
            setCartCount(updated.item_count);
            updateCommercialProgress(updated);
            return renderDrawerFast(updated);
          }).catch(function (error) { showToast(error.message); removeGift.disabled = false; });
        });
        actions.appendChild(removeGift);
      } else {
        var controls = document.createElement('div');
        controls.className = 'gd-quantity';
        ['−', '+'].forEach(function (label, index) {
          var button = document.createElement('button');
          button.type = 'button';
          if (!index && item.quantity === 1) {
            button.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v5M14 11v5"/></svg>';
            button.setAttribute('aria-label', 'Excluir ' + item.product_title + ' do carrinho');
          } else {
            button.textContent = label;
            button.setAttribute('aria-label', index ? 'Aumentar quantidade' : 'Diminuir quantidade');
          }
          button.addEventListener('click', function () {
            button.disabled = true;
            changeCart(item.key, Math.max(0, item.quantity + (index ? 1 : -1)))
              .then(function (updated) {
                setCartCount(updated.item_count);
                updateCommercialProgress(updated);
                return renderDrawerFast(updated);
              })
              .catch(function (error) { showToast(error.message); button.disabled = false; });
          });
          controls.appendChild(button);
          if (!index) {
            var amount = document.createElement('span');
            amount.textContent = item.quantity;
            amount.setAttribute('aria-label', 'Quantidade ' + item.quantity);
            controls.appendChild(amount);
          }
        });
        actions.appendChild(controls);
      }
      body.appendChild(actions);
      article.appendChild(body);
      list.appendChild(article);
    });
    content.appendChild(list);
    renderThresholdRecommendation(cart, content);
    var originalTotal = cart.items.reduce(function (total, item) {
      var compareLinePrice = Number(item.gd_compare_at_price || 0) * Number(item.quantity || 0);
      return total + Math.max(Number(item.original_line_price || 0), compareLinePrice, Number(item.final_line_price || 0));
    }, 0);
    var shopifyDiscount = Math.max(0, Number(cart.total_discount || 0));
    var coupon = window.GDCartCoupon(cart);
    pendingCartCoupon = coupon ? coupon.code : '';
    var priceSavings = Math.max(0, originalTotal - Number(cart.original_total_price || cart.total_price || 0));
    var savings = priceSavings + shopifyDiscount;
    var footer = document.createElement('div');
    footer.className = 'gd-cart-drawer__footer';
    var subtotal = document.createElement('p');
    subtotal.className = 'gd-cart-drawer__subtotal';
    var subtotalLabel = document.createElement('span');
    subtotalLabel.textContent = 'Subtotal';
    var subtotalValues = document.createElement('span');
    subtotalValues.className = 'gd-cart-drawer__subtotal-values';
    if (savings > 0) {
      var original = document.createElement('small');
      original.appendChild(document.createTextNode('De '));
      var crossed = document.createElement('s');
      crossed.textContent = money(originalTotal, cart.currency);
      crossed.dataset.gdDrawerOriginalTotal = '';
      crossed.dataset.gdBaseTotal = String(originalTotal);
      original.appendChild(crossed);
      original.appendChild(document.createTextNode(' por'));
      subtotalValues.appendChild(original);
    }
    var current = document.createElement('strong');
    current.textContent = money(cart.total_price, cart.currency);
    current.dataset.gdDrawerEstimatedTotal = '';
    current.dataset.gdBaseTotal = String(cart.total_price);
    current.dataset.gdCurrency = cart.currency;
    subtotalLabel.dataset.gdDrawerSubtotalLabel = '';
    subtotalValues.appendChild(current);
    subtotal.appendChild(subtotalLabel);
    subtotal.appendChild(subtotalValues);
    footer.appendChild(subtotal);
    if (window.GDShippingUI) window.GDShippingUI.addDrawerSummary(footer);
    if (coupon) {
      var couponDiscount = document.createElement('p');
      couponDiscount.className = 'gd-cart-drawer__discount gd-cart-drawer__discount--coupon';
      var couponLabel = document.createElement('span');
      couponLabel.textContent = 'Cupom ' + coupon.code + ' — Desconto de';
      var couponValue = document.createElement('strong');
      couponValue.textContent = '− ' + money(coupon.amount, cart.currency);
      couponDiscount.appendChild(couponLabel);
      couponDiscount.appendChild(couponValue);
      footer.appendChild(couponDiscount);
    }
    var otherDiscount = Math.max(0, shopifyDiscount - (coupon ? coupon.amount : 0));
    if (otherDiscount > 0) {
      var automaticDiscount = document.createElement('p');
      automaticDiscount.className = 'gd-cart-drawer__discount';
      var automaticDiscountLabel = document.createElement('span');
      automaticDiscountLabel.textContent = coupon ? 'Outros descontos aplicados' : 'Desconto aplicado pela Gota Dourada';
      var automaticDiscountValue = document.createElement('strong');
      automaticDiscountValue.textContent = '− ' + money(otherDiscount, cart.currency);
      automaticDiscount.appendChild(automaticDiscountLabel);
      automaticDiscount.appendChild(automaticDiscountValue);
      footer.appendChild(automaticDiscount);
    }
    if (savings > 0) {
      var saved = document.createElement('p');
      saved.className = 'gd-cart-drawer__savings';
      var savedLabel = document.createElement('span');
      savedLabel.textContent = 'Total economizado';
      var savedValue = document.createElement('strong');
      savedValue.textContent = money(savings, cart.currency);
      saved.appendChild(savedLabel);
      saved.appendChild(savedValue);
      footer.appendChild(saved);
    }
    var checkout = document.createElement('a');
    checkout.href = rootUrl + 'checkout';
    checkout.className = 'gd-button gd-button--full gd-cart-drawer__checkout';
    if (content.dataset.gdShippingUnlocked === 'true') checkout.classList.add('gd-cart-drawer__checkout--shipping-unlocked');
    checkout.insertAdjacentHTML('beforeend', '<svg class="gd-cart-drawer__checkout-lock" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>');
    var checkoutLabel = document.createElement('span');
    checkoutLabel.textContent = 'Finalizar pagamento • ';
    var checkoutAmount = document.createElement('span');
    checkoutAmount.setAttribute('data-gd-cart-checkout-amount', '');
    checkoutAmount.textContent = money(cart.total_price, cart.currency);
    checkoutLabel.appendChild(checkoutAmount);
    checkout.appendChild(checkoutLabel);
    appendCartCoupon(couponHost || footer, checkout);
    var drawer = document.querySelector('[data-gd-cart-drawer]');
    if (drawer && drawer.dataset.gdTermsRequired === 'true') {
      var consent = document.createElement('label');
      consent.className = 'gd-cart-terms';
      var consentInput = document.createElement('input');
      consentInput.type = 'checkbox';
      consentInput.required = true;
      consentInput.setAttribute('data-gd-cart-terms', '');
      var consentText = document.createElement('span');
      consentText.textContent = drawer.dataset.gdTermsText || 'Li e aceito os termos de uso da loja.';
      if (drawer.dataset.gdTermsUrl) {
        var termsLink = document.createElement('a');
        termsLink.href = drawer.dataset.gdTermsUrl;
        termsLink.target = '_blank';
        termsLink.rel = 'noopener noreferrer';
        termsLink.textContent = ' Ler termos';
        consentText.appendChild(termsLink);
      }
      consentInput.checked = termsAccepted();
      consentInput.addEventListener('change', function () { saveTermsAcceptance(consentInput.checked); });
      consent.appendChild(consentInput);
      consent.appendChild(consentText);
      (couponHost || footer).appendChild(consent);
      checkout.setAttribute('aria-disabled', String(!consentInput.checked));
      checkout.addEventListener('click', function (event) {
        if (consentInput.checked) return;
        event.preventDefault();
        consentInput.focus();
        showToast('Aceite os termos para continuar ao checkout.');
      });
      consentInput.addEventListener('change', function () {
        checkout.setAttribute('aria-disabled', String(!consentInput.checked));
      });
    }
    footer.appendChild(checkout);
    var continueShopping = document.createElement('button');
    continueShopping.type = 'button';
    continueShopping.className = 'gd-button gd-button--outline gd-button--full gd-cart-drawer__continue-shopping';
    continueShopping.textContent = 'Continuar comprando';
    continueShopping.addEventListener('click', closeDrawer);
    footer.appendChild(continueShopping);
    var cartLink = document.createElement('a');
    cartLink.href = rootUrl + 'cart';
    cartLink.className = 'gd-cart-drawer__view-cart';
    cartLink.textContent = 'Ver meu carrinho';
    footer.appendChild(cartLink);
    footer.appendChild(createCartTrustRow());
    (footerHost || content).appendChild(footer);
    if (window.GDShippingUI) window.GDShippingUI.updateSummaries();
  }

  function openDrawer(trigger, confirmedCart) {
    var drawer = document.querySelector('[data-gd-cart-drawer]');
    if (!drawer || (document.body && document.body.dataset.gdQuickCartEnabled === 'false')) return;
    var openRequest = ++drawerOpenRequest;
    var renderVersion = ++drawerRenderVersion;
    var content = drawer.querySelector('[data-gd-cart-content]');
    var loadingTemplate = drawer.querySelector('[data-gd-cart-loading-template]');
    if (content && loadingTemplate) content.replaceChildren(loadingTemplate.content.cloneNode(true));
    var summary = drawer.querySelector('[data-gd-cart-summary]');
    var auxiliary = drawer.querySelector('[data-gd-cart-auxiliary]');
    if (summary) summary.hidden = true;
    if (auxiliary) auxiliary.hidden = true;
    window.clearTimeout(drawerCloseTimer);
    drawer.classList.remove('is-closing');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gd-drawer-open');
    lastDialogTrigger = trigger || document.activeElement;
    var close = drawer.querySelector('[data-gd-cart-close]');
    if (close) close.focus();
    var cartRequest = isCompleteCart(confirmedCart)
      ? Promise.resolve(confirmedCart)
      : request(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
    cartRequest
      .then(function (cart) {
        if (openRequest !== drawerOpenRequest || renderVersion !== drawerRenderVersion) return;
        if (!isCompleteCart(cart)) throw new Error('Não foi possível carregar seu carrinho.');
        setCartCount(cart.item_count);
        return renderDrawerFast(cart);
      })
      .catch(function (error) {
        if (openRequest !== drawerOpenRequest || renderVersion !== drawerRenderVersion) return;
        if (content) {
          var failure = document.createElement('div');
          failure.className = 'gd-cart-drawer__load-error';
          failure.setAttribute('role', 'alert');
          var title = document.createElement('strong');
          title.textContent = 'Não foi possível carregar seu carrinho.';
          var description = document.createElement('p');
          description.textContent = 'Tente novamente para ver seus produtos.';
          var retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'gd-button gd-button--dark';
          retry.textContent = 'Tentar novamente';
          retry.addEventListener('click', function () { openDrawer(trigger); });
          failure.appendChild(title);
          failure.appendChild(description);
          failure.appendChild(retry);
          content.replaceChildren(failure);
        }
        showToast(error.message);
      });
  }

  function quickCartEnabled() {
    return !(document.body && document.body.dataset.gdQuickCartEnabled === 'false');
  }

  function termsAccepted() {
    try { return window.sessionStorage.getItem('gd:terms-accepted') === 'true'; } catch (error) { return false; }
  }

  function checkoutTermsRequired() {
    var drawer = document.querySelector('[data-gd-cart-drawer]');
    return Boolean(drawer && drawer.dataset.gdTermsRequired === 'true');
  }

  function saveTermsAcceptance(accepted) {
    try {
      if (accepted) window.sessionStorage.setItem('gd:terms-accepted', 'true');
      else window.sessionStorage.removeItem('gd:terms-accepted');
    } catch (error) { /* Native required validation remains active. */ }
  }

  function bindMobileCartCheckout() {
    document.querySelectorAll('[data-gd-mobile-cart-checkout]').forEach(function (link) {
      if (link.dataset.gdBound) return;
      link.dataset.gdBound = 'true';
      link.href = rootUrl + 'checkout';
      link.addEventListener('click', function (event) {
        if (!checkoutTermsRequired() || termsAccepted()) return;
        event.preventDefault();
        if (quickCartEnabled()) openDrawer(link);
        else window.location.assign(rootUrl + 'cart');
        showToast('Aceite os termos para continuar ao checkout.');
      });
    });
  }

  function bindTermsGuard(scope) {
    (scope || document).querySelectorAll('[data-gd-cart-terms]').forEach(function (input) {
      if (input.dataset.gdTermsBound) return;
      input.dataset.gdTermsBound = 'true';
      input.checked = termsAccepted();
      input.addEventListener('change', function () { saveTermsAcceptance(input.checked); });
    });
  }

  function afterAdd(trigger, message, cart) {
    if (cart && cart.gdWasEmptyBeforeAdd && Number(cart.item_count) > 0) {
      if (quickCartEnabled()) openDrawer(trigger, cart);
      else window.location.href = rootUrl + 'cart';
      return;
    }
    var policy = document.body && document.body.dataset.gdAfterAdd ? document.body.dataset.gdAfterAdd : 'toast';
    if (policy === 'none') return;
    showToast(message);
    highlightMobileCartPreview();
  }

  function loadNativeComplements(cart) {
    var host = document.querySelector('[data-gd-native-recommendations-host]');
    var source = cart.items && cart.items[0];
    if (!host) return Promise.resolve();
    if (!source) {
      host.dataset.gdProductId = '';
      host.textContent = '';
      nativeComplementsRequest = null;
      return Promise.resolve();
    }
    var productId = String(source.product_id);
    if (host.dataset.gdProductId === productId && nativeComplementsRequest) return nativeComplementsRequest.promise;
    host.dataset.gdProductId = productId;
    host.textContent = '';
    var renderRecommendations = function (data) {
      if (host.dataset.gdProductId !== productId) return;
      var rendered = 0;
      (data.products || []).forEach(function (product) {
        if (rendered >= 5) return;
        if (product.available === false) return;
        var variant = (product.variants || []).find(function (item) { return item.available; });
        if (!variant) return;
        rendered += 1;
        var candidate = document.createElement('span');
        candidate.setAttribute('data-gd-best-seller', '');
        candidate.setAttribute('data-gd-native-complement', '');
        candidate.dataset.productId = product.id;
        candidate.dataset.variantId = variant.id;
        candidate.dataset.price = variant.price;
        candidate.dataset.url = product.url;
        candidate.dataset.title = product.title;
        candidate.dataset.variantTitle = variant.title || '';
        candidate.dataset.image = product.featured_image || (product.images && product.images[0]) || '';
        host.appendChild(candidate);
      });
    };
    var recommendationUrl = function (intent) {
      return rootUrl + 'recommendations/products.json?product_id=' + encodeURIComponent(source.product_id) + '&limit=5&intent=' + intent;
    };
    var pending = request(recommendationUrl('complementary'), { headers: { Accept: 'application/json' } })
      .then(function (data) {
        if (host.dataset.gdProductId !== productId) return;
        if ((data.products || []).length) {
          renderRecommendations(data);
          return;
        }
        return request(recommendationUrl('related'), { headers: { Accept: 'application/json' } })
          .then(renderRecommendations);
      })
      .catch(function () {
        if (host.dataset.gdProductId !== productId) return;
        host.textContent = '';
        host.dataset.gdProductId = '';
        nativeComplementsRequest = null;
      });
    nativeComplementsRequest = { promise: pending };
    return pending;
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-gd-cart-drawer]');
    if (!drawer) return;
    if (!drawer.classList.contains('is-open')) return;
    drawerOpenRequest += 1;
    drawerRenderVersion += 1;
    cartCouponExpanded = false;
    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    drawer.setAttribute('aria-hidden', 'true');
    window.clearTimeout(drawerCloseTimer);
    drawerCloseTimer = window.setTimeout(function () {
      drawer.classList.remove('is-closing');
      document.documentElement.classList.remove('gd-drawer-open');
      request(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(updateMobileCartPreview)
        .catch(function () { /* Preserve the last known preview state if refresh fails. */ });
      if (lastDialogTrigger && document.contains(lastDialogTrigger)) lastDialogTrigger.focus();
      lastDialogTrigger = null;
    }, 300);
  }

  function openProductCart(trigger) { if (quickCartEnabled()) openDrawer(trigger); else window.location.href = rootUrl + 'cart'; }

  function restoreProductPurchaseActions(form) {
    if (!form || !form.hasAttribute('data-gd-product-form')) return;
    form.querySelectorAll('[data-gd-primary-purchase-actions], .gd-product-form__actions, [data-gd-submit], [data-gd-buy-now]').forEach(function (node) {
      node.hidden = false;
      node.style.removeProperty('display');
      node.style.removeProperty('visibility');
      node.style.removeProperty('opacity');
    });
    var buyNow = form.querySelector('[data-gd-buy-now]');
    if (buyNow) buyNow.hidden = Number(form.dataset.gdProductPageAddCount || 0) > 0;
  }

  function recordProductPageAdd(form, quantity) {
    var section = form.closest('[data-gd-product-root]');
    if (!section) return;
    restoreProductPurchaseActions(form);
    var count = (Number(form.dataset.gdProductPageAddCount) || 0) + quantity;
    var label = 'Adicionar mais uma unidade deste produto. ' + count + ' adicionadas nesta página';
    form.dataset.gdProductPageAddCount = String(count);
    var submit = form.querySelector('[data-gd-submit]'), actions = form.querySelector('[data-gd-product-added-actions]');
    var buyNow = form.querySelector('[data-gd-buy-now]');
    var stickySubmit = section.querySelector('[data-gd-sticky-submit]');
    if (submit) submit.hidden = false;
    if (buyNow) buyNow.hidden = true;
    if (actions) actions.hidden = false;
    if (stickySubmit) {
      stickySubmit.textContent = form.dataset.gdSelectedAvailable === 'false' ? 'Indisponível' : 'Adicionar';
      stickySubmit.disabled = form.dataset.gdSelectedAvailable === 'false';
    }
    section.querySelectorAll('span[data-gd-product-added-count]').forEach(function (node) { node.textContent = String(count); });
    section.querySelectorAll('[data-gd-product-add-more]').forEach(function (button) {
      button.hidden = false;
      button.setAttribute('aria-label', label);
    });
    var preview = document.querySelector('[data-gd-product-offer]');
    if (preview) {
      var previewAdd = preview.querySelector('[data-gd-preview-add]'), previewActions = preview.querySelector('[data-gd-preview-added-actions]');
      var previewCount = preview.querySelector('[data-gd-preview-added-count]'), previewMore = preview.querySelector('[data-gd-preview-add-more]');
      if (previewAdd) previewAdd.hidden = true;
      if (previewActions) previewActions.hidden = false;
      if (previewCount) previewCount.textContent = String(count);
      if (previewMore) previewMore.setAttribute('aria-label', label);
    }
  }

  function bindAddForms(scope) {
    (scope || document).querySelectorAll('[data-gd-add-form], [data-gd-product-form]').forEach(function (form) {
      if (form.dataset.gdBound) return;
      form.dataset.gdBound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (form.dataset.gdAdding === 'true') return;
        var button = form.querySelector('[type="submit"]');
        var id = form.querySelector('[name="id"]');
        var quantity = form.querySelector('[name="quantity"]');
        var errorNode = form.querySelector('[data-gd-product-error]');
        if (!id || !id.value || !button) return;
        var isProductForm = form.hasAttribute('data-gd-product-form');
        var previewProductForm = form.closest('[data-gd-product-offer]') && document.querySelector('[data-gd-product-form]');
        if (previewProductForm) {
          var selectedId = previewProductForm.querySelector('[data-gd-variant-id]');
          if (!selectedId || !selectedId.value || previewProductForm.dataset.gdSelectedAvailable === 'false') return;
          id.value = selectedId.value;
        }
        var requestedQuantity = form.dataset.gdAddOne === 'true' ? 1 : Math.max(1, Number(quantity && quantity.value) || 1);
        delete form.dataset.gdAddOne;
        form.dataset.gdAdding = 'true';
        var originalChildren = Array.prototype.slice.call(button.childNodes);
        button.disabled = true;
        button.textContent = 'Adicionando…';
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (errorNode) errorNode.hidden = true;
        var section = form.closest('[data-gd-product-root]');
        if (section && isProductForm) section.querySelectorAll('[data-gd-product-add-more]').forEach(function (addMore) { addMore.disabled = true; });
        var previewMore = form.querySelector('[data-gd-preview-add-more]');
        if (previewMore) previewMore.disabled = true;
        gdCart.add([{ id: Number(id.value), quantity: requestedQuantity }]).then(function (cart) {
          setCartCount(cart.item_count);
          updateMobileCartPreview(cart);
          if (isProductForm) recordProductPageAdd(form, requestedQuantity);
          else if (previewProductForm) recordProductPageAdd(previewProductForm, requestedQuantity);
          trackCommerceEvent('gd_add_to_cart', { source: form.hasAttribute('data-gd-bulk-add') ? 'bundle' : 'product' });
          if (form.closest('[data-gd-cart-drawer]')) {
            if (!cart.gdWasEmptyBeforeAdd && (!document.body || document.body.dataset.gdAfterAdd !== 'none')) showToast('Produto adicionado ao carrinho.');
            return renderDrawerFast(cart);
          }
          afterAdd(button, 'Produto adicionado ao carrinho.', cart);
        }).catch(function (error) {
          if (errorNode) { errorNode.textContent = error.message; errorNode.hidden = false; }
          showToast(error.message);
        }).finally(function () {
          delete form.dataset.gdAdding;
          button.disabled = isProductForm && form.dataset.gdSelectedAvailable === 'false';
          button.replaceChildren.apply(button, originalChildren);
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          restoreProductPurchaseActions(isProductForm ? form : previewProductForm);
          if (section && isProductForm) section.querySelectorAll('[data-gd-product-add-more]').forEach(function (addMore) {
            addMore.disabled = form.dataset.gdSelectedAvailable === 'false';
          });
          if (previewMore) previewMore.disabled = Boolean(previewProductForm && previewProductForm.dataset.gdSelectedAvailable === 'false');
        });
      });
    });
  }

  var currentCartShippingSubtotal = null;

  function shippingCardSubtotal() {
    if (currentCartShippingSubtotal !== null) return currentCartShippingSubtotal;
    var source = document.querySelector('[data-gd-progress-config] [data-gd-commercial-progress]');
    return source ? Number(source.dataset.gdCartSubtotal || 0) : 0;
  }

  function fitShippingCardBadge(badge) {
    if (badge.hidden || !badge.clientWidth) return;
    badge.style.fontSize = '10px';
    for (var size = 9.5; badge.scrollWidth > badge.clientWidth && size >= 5.5; size -= .5) {
      badge.style.fontSize = size + 'px';
    }
  }

  function updateShippingCardBadge(card, subtotal, price, available) {
    var badge = card.querySelector('[data-gd-card-context]');
    var freeShippingBadge = card.querySelector('[data-gd-card-free-shipping]');
    if (!badge && !freeShippingBadge) return;
    var selected = card.querySelector('[data-gd-card-variant].is-active');
    if (price == null) price = Number(selected ? selected.dataset.price : card.dataset.gdProductPrice) || 0;
    if (available == null) available = selected ? selected.dataset.available === 'true' : card.dataset.gdProductAvailable === 'true';
    var minimum = Number(card.dataset.gdFreeShippingMinimum || 0);
    var qualifiesAlone = available && card.dataset.gdFreeShippingActive === 'true' &&
      minimum > 0 && price >= minimum;
    if (freeShippingBadge) freeShippingBadge.hidden = !qualifiesAlone;
    if (!badge) return;
    var canReach = available && !qualifiesAlone && card.dataset.gdFreeShippingActive === 'true' &&
      minimum > 0 && subtotal < minimum && subtotal + price >= minimum;
    badge.hidden = available && !canReach;
    badge.textContent = available ? (canReach ? 'Adicione para ganhar frete grátis*' : '') : 'Indisponível';
    badge.classList.toggle('gd-product-card__badge--shipping', canReach);
    badge.classList.toggle('gd-product-card__badge--out', !available);
    if (canReach) fitShippingCardBadge(badge);
  }

  function syncShippingCardBadges(cart) {
    currentCartShippingSubtotal = rewardSubtotal(cart);
    document.querySelectorAll('[data-gd-product-card]').forEach(function (card) {
      updateShippingCardBadge(card, currentCartShippingSubtotal);
    });
  }

  function initProductCards(scope) {
    if (!document.documentElement.dataset.gdShippingBadgeResizeBound) {
      document.documentElement.dataset.gdShippingBadgeResizeBound = 'true';
      window.addEventListener('resize', function () {
        document.querySelectorAll('[data-gd-card-context].gd-product-card__badge--shipping').forEach(fitShippingCardBadge);
      });
    }
    (scope || document).querySelectorAll('[data-gd-product-card]').forEach(function (card) {
      if (card.dataset.gdVariantsBound) return;
      card.dataset.gdVariantsBound = 'true';
      var form = card.querySelector('[data-gd-add-form]');
      var idInput = form && form.querySelector('[name="id"]');
      var submit = card.querySelector('[data-gd-card-submit]');
      var currentPrice = card.querySelector('[data-gd-card-current-price]');
      var comparePrice = card.querySelector('[data-gd-card-compare]');
      var discountBadge = card.querySelector('[data-gd-card-discount]');
      var contextBadge = card.querySelector('[data-gd-card-context]');
      var media = card.querySelector('.gd-product-card__media');
      updateShippingCardBadge(card, shippingCardSubtotal());

      function updateSubmitLabel(available) {
        if (!submit) return;
        var desktopLabel = submit.querySelector('.gd-card-quick-label--desktop');
        var mobileLabel = submit.querySelector('.gd-card-quick-label--mobile');
        if (desktopLabel && mobileLabel) {
          desktopLabel.textContent = available ? 'Adicionar ao carrinho' : 'Avise-me';
          mobileLabel.textContent = available ? 'Adicionar' : 'Avise-me';
        } else {
          submit.textContent = available ? 'Adicionar ao carrinho' : 'Avise-me';
        }
      }

      card.querySelectorAll('[data-gd-card-variant]').forEach(function (button) {
        button.addEventListener('click', function () {
          var price = Number(button.dataset.price || 0);
          var compare = Number(button.dataset.compareAtPrice || 0);
          var available = button.dataset.available === 'true';
          var hasDiscount = compare > price;

          card.querySelectorAll('[data-gd-card-variant]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          if (idInput) idInput.value = button.dataset.variantId;
          if (currentPrice) currentPrice.textContent = money(price);
          if (comparePrice) {
            comparePrice.hidden = !hasDiscount;
            var compareText = comparePrice.querySelector('s');
            if (compareText) compareText.textContent = hasDiscount ? money(compare) : '';
          }
          if (discountBadge) {
            discountBadge.hidden = !hasDiscount;
            discountBadge.textContent = hasDiscount ? Math.floor((compare - price) * 100 / compare) + '% OFF' : '';
          }
          if (contextBadge) {
            updateShippingCardBadge(card, currentCartShippingSubtotal, price, available);
          }
          card.classList.toggle('is-unavailable', !available);
          if (media) media.classList.toggle('is-unavailable', !available);
          if (submit) {
            submit.disabled = !available;
            updateSubmitLabel(available);
            submit.classList.toggle('gd-button--notify', !available);
          }
          card.querySelectorAll('[data-gd-card-terms]').forEach(function (terms) {
            terms.hidden = terms.dataset.gdCardTerms !== button.dataset.variantId;
          });
        });
      });
    });
  }

  function initCampaignSingleProducts(scope) {
    (scope || document).querySelectorAll('[data-gd-single-product]').forEach(function (productSection) {
      if (productSection.dataset.gdSingleProductBound) return;
      productSection.dataset.gdSingleProductBound = 'true';
      var select = productSection.querySelector('select[name="id"]');
      var price = productSection.querySelector('[data-gd-single-price]');
      var submit = productSection.querySelector('button[type="submit"]');
      if (!select || !price) return;

      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        if (option.dataset.price) price.textContent = option.dataset.price;
        if (submit) submit.disabled = option.disabled;
      });
    });
  }

  function initProduct(section) {
    if (!section || section.dataset.gdInitialized) return;
    section.dataset.gdInitialized = 'true';
    var form = section.querySelector('[data-gd-product-form]');
    var json = section.querySelector('[data-gd-variants]');
    if (!form || !json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }
    var offerVariants = [];
    var offerJson = section.querySelector('[data-gd-offer-variants]');
    if (offerJson) {
      try { offerVariants = JSON.parse(offerJson.textContent); } catch (error) { offerVariants = []; }
      if (!Array.isArray(offerVariants)) offerVariants = [];
    }
    initProductPurchaseVisibility(section);
    var idInput = form.querySelector('[data-gd-variant-id]');
    var baseVariantId = idInput && idInput.value;
    var submit = form.querySelector('[data-gd-submit]');
    var buyNow = form.querySelector('[data-gd-buy-now]');
    var stickySubmit = section.querySelector('[data-gd-sticky-submit]');
      var notifyStock = section.querySelector('[data-gd-notify-stock]');
      var quantityInput = form.querySelector('[name="quantity"]');
    var productCurrency = section.dataset.gdCurrency || 'BRL';
    var lowestUnitPrice = variants.reduce(function (lowest, item) { return item.unit_price && (!lowest || item.unit_price < lowest) ? item.unit_price : lowest; }, 0);

    function syncPreviewVariant(variant) {
      var preview = document.querySelector('[data-gd-product-offer]');
      if (!preview) return;
      var previewId = preview.querySelector('[name="id"]');
      var previewPrice = preview.querySelector('[data-gd-preview-product-price]');
      var previewImage = preview.querySelector('[data-gd-preview-product-image]');
      if (previewId) previewId.value = variant ? variant.id : '';
      if (previewPrice && variant) previewPrice.textContent = money(variant.price, productCurrency);
      var previewVariantImage = variant && (
        variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src ||
        variant.featured_image && variant.featured_image.src
      ) || variant.gd_product_image || section.dataset.gdProductImage;
      if (previewImage && previewVariantImage) {
        var previewImageUrl = new URL(previewVariantImage, window.location.href);
        previewImageUrl.searchParams.set('width', '100');
        previewImage.src = previewImageUrl.href;
      }
      preview.querySelectorAll('[data-gd-preview-add], [data-gd-preview-add-more]').forEach(function (button) {
        button.disabled = !variant || !variant.available;
      });
    }

    function showMedia(id) {
      if (!id) return;
      section.querySelectorAll('[data-gd-media-id]').forEach(function (slide) {
        var active = String(slide.dataset.gdMediaId) === String(id);
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      section.querySelectorAll('[data-gd-gallery-thumb]').forEach(function (thumb) { thumb.setAttribute('aria-selected', String(String(thumb.dataset.gdGalleryThumb) === String(id))); });
    }

    function selectVariant() {
      var selected = Array.prototype.map.call(form.querySelectorAll('[data-gd-option-position]'), function (field) {
        var checked = field.querySelector('input:checked');
        return checked ? checked.value : '';
      });
      var choice = form.querySelector('input[name="gd_purchase_choice"]:checked');
      var choiceValue = choice ? choice.value : 'base';
      var resolved = window.GdProductChoices
        ? window.GdProductChoices.resolveChoice(variants, offerVariants, baseVariantId, selected, choiceValue)
        : { variant: choiceValue !== 'base' ? null : (selected.length ? variants.find(function (item) { return item.options.every(function (option, index) { return option === selected[index]; }); }) : variants.find(function (item) { return String(item.id) === String(baseVariantId); }) || variants[0]), isOffer: false };
      var variant = resolved.variant;
      var isOffer = resolved.isOffer;
      var baseVariant = resolved.baseVariant;
      if (!isOffer && variant) baseVariantId = variant.id;
      form.querySelectorAll('[data-gd-option-position]').forEach(function (field) { field.hidden = isOffer; });
      var choiceStatus = section.querySelector('[data-gd-choice-status]');
      if (choiceStatus) choiceStatus.textContent = variant ? 'Opção selecionada: ' + (isOffer ? variant.gd_product_title : section.dataset.gdProductTitle) : 'Opção indisponível';
      var baseChoicePrice = section.querySelector('[data-gd-base-choice-price]');
      var baseChoiceCompare = section.querySelector('[data-gd-base-choice-compare]');
      if (baseChoicePrice && baseVariant) baseChoicePrice.textContent = money(baseVariant.price, productCurrency);
      if (baseChoiceCompare && baseVariant) {
        baseChoiceCompare.textContent = baseVariant.compare_at_price > baseVariant.price ? money(baseVariant.compare_at_price, productCurrency) : '';
        baseChoiceCompare.hidden = !(baseVariant.compare_at_price > baseVariant.price);
      }
      if (!variant) {
        idInput.value = '';
        syncPreviewVariant(null);
        form.dataset.gdSelectedAvailable = 'false';
        submit.disabled = true;
        submit.textContent = 'Combinação indisponível';
        if (buyNow) buyNow.disabled = true;
        if (stickySubmit) { stickySubmit.disabled = true; stickySubmit.textContent = 'Indisponível'; }
        section.querySelectorAll('[data-gd-product-add-more]').forEach(function (button) { button.disabled = true; });
        return;
      }
      idInput.value = variant.id;
      form.dataset.gdSelectedProductId = String(isOffer ? variant.gd_product_id : section.dataset.gdProductId);
      form.dataset.gdSelectedProductTitle = isOffer ? variant.gd_product_title : section.dataset.gdProductTitle;
      syncPreviewVariant(variant);
      form.dataset.gdSelectedAvailable = String(Boolean(variant.available));
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Adicionar ao carrinho' : 'Indisponível';
      if (buyNow) { buyNow.disabled = !variant.available; buyNow.textContent = variant.available ? 'Compre já' : 'Indisponível'; }
      if (stickySubmit) {
        stickySubmit.disabled = !variant.available;
        stickySubmit.textContent = variant.available ? 'Adicionar' : 'Indisponível';
      }
      section.querySelectorAll('[data-gd-product-add-more]').forEach(function (button) { button.disabled = !variant.available; });
      var current = section.querySelector('[data-gd-current-price]');
      var compare = section.querySelector('[data-gd-compare]');
      var discount = section.querySelector('[data-gd-discount]');
      var stickyPrice = section.querySelector('[data-gd-sticky-price]');
      var stickyCompare = section.querySelector('[data-gd-sticky-compare]');
      var stickyInstallment = section.querySelector('[data-gd-sticky-installment]');
      var stickyImage = section.querySelector('[data-gd-sticky-image]');
      var sku = section.querySelector('[data-gd-sku]');
      if (current) current.textContent = money(variant.price, productCurrency);
      if (stickyPrice) stickyPrice.textContent = money(variant.price, productCurrency);
      if (stickyCompare) {
        stickyCompare.hidden = !(variant.compare_at_price > variant.price);
        stickyCompare.textContent = variant.compare_at_price > variant.price ? 'De ' + money(variant.compare_at_price, productCurrency) : '';
      }
      if (stickyInstallment) stickyInstallment.textContent = 'ou 3x de ' + money(Math.round(variant.price / 3), productCurrency);
      var stickyVariantImage = variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src ||
        variant.featured_image && variant.featured_image.src ||
        section.dataset.gdProductImage;
      if (stickyImage && stickyVariantImage) stickyImage.src = stickyVariantImage;
      if (sku) { sku.hidden = !variant.sku; sku.querySelector('span').textContent = variant.sku || ''; }
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.innerHTML = variant.compare_at_price > variant.price ? 'De <s>' + money(variant.compare_at_price, productCurrency) + '</s> por' : '';
      }
      if (discount) {
        discount.hidden = !(variant.compare_at_price > variant.price);
        discount.textContent = variant.compare_at_price > variant.price ? '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%' : '';
      }
      if (notifyStock) notifyStock.hidden = variant.available;
      var notifyBody = section.querySelector('[data-gd-notify-body]');
      if (notifyBody) notifyBody.value = 'Interesse em ' + (notifyBody.dataset.gdProductTitle || '') + ' — variante ' + (variant.title || '') + '.';
      var notifyTags = section.querySelector('[data-gd-notify-tags]');
      if (notifyTags) notifyTags.value = 'aviso-estoque,aviso:' + variant.id;
      var terms = section.querySelector('[data-gd-payment-terms]');
      if (terms) {
        var installments = terms.querySelector('[data-gd-installment]');
        var installmentCountNode = terms.querySelector('[data-gd-installment-count]');
        var installmentRow = terms.querySelector('[data-gd-installment-row]');
        var pix = terms.querySelector('[data-gd-pix-price]');
        var installmentCount = 3;
        var installmentPayment = Math.round(variant.price / installmentCount);
        if (installmentCountNode) installmentCountNode.textContent = installmentCount;
        if (installments) installments.textContent = money(installmentPayment, productCurrency);
        if (installmentRow) installmentRow.hidden = false;
        if (pix && section.dataset.gdPixEnabled === 'true') pix.textContent = money(Math.floor(variant.price * (100 - (Number(section.dataset.gdPixDiscount) || 0)) / 100), productCurrency);
      }
      if (!isOffer) showMedia(variant.featured_media && variant.featured_media.id);
       var unitPrice = section.querySelector('[data-gd-unit-price]');
       if (unitPrice) {
         var measurement = variant.unit_price_measurement;
         unitPrice.hidden = !measurement || !variant.unit_price;
         if (!unitPrice.hidden) unitPrice.textContent = money(variant.unit_price, productCurrency) + ' / ' + measurement.reference_value + ' ' + measurement.reference_unit + (!isOffer && variant.unit_price === lowestUnitPrice ? ' — Melhor preço por unidade' : '');
       }
       section.querySelectorAll('[data-gd-option-position] label').forEach(function (label) {
         var radio = label.querySelector('input');
         if (!radio) return;
         var optionIndex = Number(label.closest('[data-gd-option-position]').dataset.gdOptionPosition) - 1;
         var selectedOptions = [];
         form.querySelectorAll('[data-gd-option-position]').forEach(function (fieldset) {
           var selected = fieldset.querySelector('input:checked');
           selectedOptions[Number(fieldset.dataset.gdOptionPosition) - 1] = selected && selected.value;
         });
         var compatibleAvailable = variants.some(function (item) {
           if (!item.available || item.options[optionIndex] !== radio.value) return false;
           return item.options.every(function (optionValue, index) {
             return index === optionIndex || !selectedOptions[index] || selectedOptions[index] === optionValue;
           });
         });
         radio.disabled = !compatibleAvailable;
         label.classList.toggle('is-unavailable', !compatibleAvailable);
         var matching = variants.filter(function (item) { return item.options[optionIndex] === radio.value && item.unit_price; });
         var best = matching.length && matching.some(function (item) { return item.unit_price === lowestUnitPrice; });
         label.classList.toggle('is-best-value', best && radio.checked);
       });
      if (!isOffer) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (!idInput.value || buyNow.disabled) return;
        var needsCartTerms = checkoutTermsRequired() && !termsAccepted();
        var original = buyNow.textContent;
        buyNow.disabled = true;
        buyNow.textContent = needsCartTerms ? 'Adicionando ao carrinho…' : 'Preparando checkout…';
        buyNow.classList.add('is-loading');
        gdCart.add([{
          id: Number(idInput.value),
          quantity: Math.max(1, Number(quantityInput && quantityInput.value) || 1)
        }]).then(function (cart) {
          setCartCount(cart.item_count);
          updateMobileCartPreview(cart);
          trackCommerceEvent('gd_buy_now', { source: 'product' });
          window.location.assign(rootUrl + (needsCartTerms ? 'cart' : 'checkout'));
        }).catch(function (error) {
          var errorNode = form.querySelector('[data-gd-product-error]');
          if (errorNode) { errorNode.textContent = error.message; errorNode.hidden = false; }
          showToast(error.message);
          buyNow.disabled = false;
          buyNow.textContent = original;
          buyNow.classList.remove('is-loading');
        });
      });
    }
    form.querySelectorAll('[data-gd-option-position] input').forEach(function (input) { input.addEventListener('change', selectVariant); });
    form.querySelectorAll('input[name="gd_purchase_choice"]').forEach(function (input) { input.addEventListener('change', selectVariant); });
    if (quantityInput) quantityInput.addEventListener('input', selectVariant);
    section.querySelectorAll('[data-gd-gallery-thumb]').forEach(function (button) { button.addEventListener('click', function () { showMedia(button.dataset.gdGalleryThumb); }); });
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-gd-media-id]'));
    function moveGallery(direction) {
      var currentIndex = slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
      var next = slides[(currentIndex + direction + slides.length) % slides.length];
      if (next) showMedia(next.dataset.gdMediaId);
    }
    var prev = section.querySelector('[data-gd-gallery-prev]');
    var next = section.querySelector('[data-gd-gallery-next]');
    if (prev) prev.addEventListener('click', function () { moveGallery(-1); });
    if (next) next.addEventListener('click', function () { moveGallery(1); });
    var stage = section.querySelector('.gd-gallery__stage');
    if (stage) {
      var touchStart = 0;
      stage.addEventListener('touchstart', function (event) { touchStart = event.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        var distance = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(distance) > 45) moveGallery(distance > 0 ? -1 : 1);
      }, { passive: true });
    }
    var zoomButton = section.querySelector('[data-gd-gallery-zoom]');
    var zoomDialog = section.querySelector('[data-gd-gallery-dialog]');
    var zoomContent = section.querySelector('[data-gd-gallery-dialog-content]');
    var zoomClose = section.querySelector('[data-gd-gallery-close]');
    var zoomScale = 1;
    var pinchDistance = 0;
    function setZoomScale(nextScale) {
      zoomScale = Math.max(1, Math.min(3, nextScale));
      if (zoomContent && zoomContent.firstElementChild) zoomContent.firstElementChild.style.transform = 'scale(' + zoomScale + ')';
    }
    if (zoomButton && zoomDialog && zoomContent) {
      zoomButton.addEventListener('click', function () {
        var activeSlide = section.querySelector('[data-gd-media-id].is-active') || section.querySelector('.gd-gallery__slide.is-active');
        if (!activeSlide) return;
        zoomContent.textContent = '';
        var clone = activeSlide.firstElementChild && activeSlide.firstElementChild.cloneNode(true);
        if (!clone) return;
        zoomContent.appendChild(clone);
        setZoomScale(1);
        if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
        else zoomDialog.setAttribute('open', '');
      });
      if (zoomClose) zoomClose.addEventListener('click', function () { zoomDialog.close(); });
      zoomDialog.addEventListener('click', function (event) { if (event.target === zoomDialog) zoomDialog.close(); });
      zoomContent.addEventListener('wheel', function (event) {
        event.preventDefault();
        setZoomScale(zoomScale + (event.deltaY < 0 ? 0.2 : -0.2));
      }, { passive: false });
      zoomContent.addEventListener('touchstart', function (event) {
        if (event.touches.length === 2) pinchDistance = Math.hypot(event.touches[0].clientX - event.touches[1].clientX, event.touches[0].clientY - event.touches[1].clientY);
      }, { passive: true });
      zoomContent.addEventListener('touchmove', function (event) {
        if (event.touches.length !== 2 || !pinchDistance) return;
        var distance = Math.hypot(event.touches[0].clientX - event.touches[1].clientX, event.touches[0].clientY - event.touches[1].clientY);
        setZoomScale(zoomScale * (distance / pinchDistance));
        pinchDistance = distance;
      }, { passive: true });
      zoomContent.addEventListener('touchend', function () { pinchDistance = 0; }, { passive: true });
    }
    section.querySelectorAll('[data-gd-product-open-cart]').forEach(function (button) {
      button.onclick = function () { openProductCart(button); };
    });
    section.querySelectorAll('[data-gd-product-add-more]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled || form.dataset.gdAdding === 'true') return;
        form.dataset.gdAddOne = 'true';
        form.requestSubmit(submit);
      });
    });
    if (stickySubmit) stickySubmit.onclick = function () { form.requestSubmit(submit); };

    selectVariant();
  }

  function initMobileHeaderSearch() {
    var toggle = document.querySelector('[data-gd-header-search-toggle]');
    var search = document.getElementById('GdHeaderSearch');
    if (!toggle || !search || toggle.dataset.gdBound) return;
    toggle.dataset.gdBound = 'true';
    var input = search.querySelector('input[type="search"]');
    var mobile = window.matchMedia('(max-width: 899px)');

    function setOpen(open, restoreFocus) {
      search.classList.toggle('is-mobile-open', open && mobile.matches);
      toggle.setAttribute('aria-expanded', String(open && mobile.matches));
      toggle.setAttribute('aria-label', open && mobile.matches ? 'Fechar busca' : 'Buscar produtos');
      if (open && mobile.matches && input) window.setTimeout(function () { input.focus(); }, 20);
      else if (restoreFocus) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      setOpen(!search.classList.contains('is-mobile-open'), true);
    });
    document.addEventListener('pointerdown', function (event) {
      if (!search.classList.contains('is-mobile-open')) return;
      if (!search.contains(event.target) && !toggle.contains(event.target)) setOpen(false, false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && search.classList.contains('is-mobile-open')) setOpen(false, true);
    });
    if (mobile.addEventListener) {
      mobile.addEventListener('change', function (event) { if (!event.matches) setOpen(false, false); });
    } else if (mobile.addListener) {
      mobile.addListener(function (event) { if (!event.matches) setOpen(false, false); });
    }
  }

  function initSearch() {
    document.querySelectorAll('[data-gd-search]').forEach(function (wrapper) {
      if (wrapper.dataset.gdBound) return;
      wrapper.dataset.gdBound = 'true';
      var input = wrapper.querySelector('input[type="search"]');
      var results = wrapper.querySelector('[data-gd-predictive]');
      var status = wrapper.querySelector('[data-gd-search-status]');
      var voiceButton = wrapper.querySelector('[data-gd-voice-search]');
      var limit = Math.max(3, Math.min(10, Number(wrapper.dataset.gdSearchLimit) || 6));
      var timer;
      var requestId = 0;
      var activeIndex = -1;
      if (!input || !results) return;

      function options() {
        return Array.prototype.slice.call(results.querySelectorAll('[role="option"], .gd-predictive__all'));
      }

      function setOpen(open) {
        results.hidden = !open;
        input.setAttribute('aria-expanded', String(open));
        if (!open) {
          activeIndex = -1;
          input.removeAttribute('aria-activedescendant');
        }
      }

      function setActive(nextIndex) {
        var items = options();
        if (!items.length) return;
        activeIndex = (nextIndex + items.length) % items.length;
        items.forEach(function (item, index) {
          if (!item.id) item.id = results.id + '-option-' + index;
          item.classList.toggle('is-active', index === activeIndex);
          item.setAttribute('aria-selected', String(index === activeIndex));
        });
        input.setAttribute('aria-activedescendant', items[activeIndex].id);
        items[activeIndex].scrollIntoView({ block: 'nearest' });
      }

      function imageUrl(result) {
        var image = result && (result.image || result.featured_image);
        if (!image) return '';
        return typeof image === 'string' ? image : (image.url || image.src || '');
      }

      function renderProduct(result) {
        var link = document.createElement('a');
        link.className = 'gd-predictive__item';
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.href = result.url || '#';

        var media = document.createElement('span');
        media.className = 'gd-predictive__media';
        var source = imageUrl(result);
        if (source) {
          var image = document.createElement('img');
          image.src = source.indexOf('?') > -1 ? source + '&width=160' : source + '?width=160';
          image.alt = '';
          image.loading = 'lazy';
          media.appendChild(image);
        } else {
          media.appendChild(document.createTextNode('GD'));
        }

        var content = document.createElement('span');
        content.className = 'gd-predictive__content';
        var type = document.createElement('small');
        type.textContent = result.product_type || 'Produto Gota Dourada';
        var title = document.createElement('strong');
        title.textContent = result.title || 'Produto Gota Dourada';
        content.appendChild(type);
        content.appendChild(title);
        if (result.price) {
          var price = document.createElement('span');
          price.className = 'gd-predictive__price';
          price.textContent = result.price;
          content.appendChild(price);
        }

        link.appendChild(media);
        link.appendChild(content);
        return link;
      }

      function renderAllResults(term) {
        var link = document.createElement('a');
        link.className = 'gd-predictive__all';
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.href = rootUrl + 'search?q=' + encodeURIComponent(term);
        link.textContent = 'Ver todos os resultados';
        return link;
      }

      input.addEventListener('input', function () {
        window.clearTimeout(timer);
        var term = input.value.trim();
        requestId += 1;
        if (term.length < 2) {
          setOpen(false);
          results.textContent = '';
          results.removeAttribute('aria-busy');
          if (status) status.textContent = '';
          return;
        }
        setOpen(true);
        results.setAttribute('aria-busy', 'true');
        results.innerHTML = '<p class="gd-predictive__status">Buscando produtos…</p>';
        results.firstElementChild.setAttribute('role', 'presentation');
        timer = window.setTimeout(function () {
          var currentRequestId = requestId;
          request(rootUrl + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=' + limit, { headers: { Accept: 'application/json' } })
            .then(function (data) {
              if (currentRequestId !== requestId) return;
              results.textContent = '';
              var found = data.resources && data.resources.results;
              var products = found && found.products || [];
              var collections = found && found.collections || [];
               var favoriteIds = {};
               readFavorites().forEach(function (item) { favoriteIds[String(item.id)] = true; });
               var previewProducts = products.map(function (result, index) {
                 return { result: result, index: index };
               }).sort(function (left, right) {
                 var leftFavorite = Boolean(favoriteIds[String(left.result.id)]);
                 var rightFavorite = Boolean(favoriteIds[String(right.result.id)]);
                 if (leftFavorite !== rightFavorite) return leftFavorite ? -1 : 1;
                 return left.index - right.index;
               }).map(function (item) { return item.result; }).slice(0, limit);
              if (previewProducts.length) {
                var heading = document.createElement('p');
                heading.className = 'gd-predictive__heading';
                heading.setAttribute('role', 'presentation');
                heading.textContent = 'Produtos';
                results.appendChild(heading);
                previewProducts.forEach(function (result) {
                  results.appendChild(renderProduct(result));
                });
              }
              collections.slice(0, 3).forEach(function (result) {
                var collection = document.createElement('a');
                collection.className = 'gd-predictive__collection';
                collection.setAttribute('role', 'option');
                collection.setAttribute('aria-selected', 'false');
                collection.href = result.url || '#';
                collection.textContent = 'Ver coleção ' + result.title;
                results.appendChild(collection);
              });
              if (previewProducts.length || collections.length) {
                results.appendChild(renderAllResults(term));
              } else {
                var empty = document.createElement('p');
                empty.className = 'gd-predictive__status';
                empty.setAttribute('role', 'presentation');
                empty.textContent = 'Não encontramos produtos para esta busca.';
                results.appendChild(empty);
              }
              results.removeAttribute('aria-busy');
              setOpen(true);
              activeIndex = -1;
              if (status) status.textContent = (previewProducts.length + collections.length) + ' sugestões disponíveis.';
            }).catch(function (error) {
              if (currentRequestId !== requestId) return;
              results.textContent = error.message || 'Não foi possível carregar a busca rápida.';
              results.classList.add('is-error');
              results.removeAttribute('aria-busy');
              setOpen(true);
              if (status) status.textContent = 'Não foi possível carregar as sugestões.';
            });
        }, 250);
      });
      input.addEventListener('focus', function () {
        if (input.value.trim().length > 1 && results.children.length) setOpen(true);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { setOpen(false); return; }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          setOpen(true);
          setActive(activeIndex + (event.key === 'ArrowDown' ? 1 : -1));
          return;
        }
        if (event.key === 'Enter' && activeIndex >= 0) {
          var active = options()[activeIndex];
          if (active) { event.preventDefault(); active.click(); }
        }
      });

      var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      var voiceRecognition = null;
      if (voiceButton && SpeechRecognition) {
        voiceButton.hidden = false;
        voiceButton.addEventListener('click', function () {
          if (voiceRecognition) {
            voiceRecognition.stop();
            voiceRecognition = null;
            voiceButton.removeAttribute('aria-pressed');
            return;
          }
          var recognition = new SpeechRecognition();
          voiceRecognition = recognition;
          recognition.lang = 'pt-BR';
          recognition.interimResults = false;
          voiceButton.setAttribute('aria-pressed', 'true');
          recognition.addEventListener('result', function (event) {
            input.value = event.results[0][0].transcript;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.focus();
          });
          recognition.addEventListener('end', function () {
            voiceRecognition = null;
            voiceButton.removeAttribute('aria-pressed');
          });
          recognition.addEventListener('error', function () {
            voiceRecognition = null;
            voiceButton.removeAttribute('aria-pressed');
            showToast('Não foi possível iniciar a busca por voz. Verifique a permissão do microfone.');
          });
          recognition.start();
        });
      }
    });
  }

  function initReveal(scope) {
    var root = scope || document;
    var targets = root.querySelectorAll('main .shopify-section');
    if (window.Shopify && window.Shopify.designMode) {
      root.querySelectorAll('main .shopify-section, [data-gd-reveal]').forEach(function (target) {
        target.classList.add('is-visible');
        target.removeAttribute('data-gd-reveal');
      });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (target) { target.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        entry.target.removeAttribute('data-gd-reveal');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: .1 });
    targets.forEach(function (target, index) {
      if (target.dataset.gdRevealBound) return;
      target.dataset.gdRevealBound = 'true';
      var box = target.getBoundingClientRect();
      if (index === 0 || box.top < window.innerHeight * .9) {
        target.classList.add('is-visible');
        return;
      }
      target.setAttribute('data-gd-reveal', '');
      observer.observe(target);
      window.setTimeout(function () {
        if (target.classList.contains('is-visible')) return;
        target.classList.add('is-visible');
        target.removeAttribute('data-gd-reveal');
        observer.unobserve(target);
      }, 1500);
    });
  }

  function initQuickView() {
    var dialog = document.querySelector('[data-gd-quick-view-dialog]');
    if (!dialog || dialog.dataset.gdBound) return;
    dialog.dataset.gdBound = 'true';
    var status = dialog.querySelector('[data-gd-quick-view-status]');
    var body = dialog.querySelector('[data-gd-quick-view-body]');
    var close = dialog.querySelector('[data-gd-quick-view-close]');
    var add = dialog.querySelector('[data-gd-quick-view-add]');
    var errorNode = dialog.querySelector('[data-gd-quick-view-error]');
    var activeTrigger = null;

    function closeDialog() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      if (activeTrigger && document.contains(activeTrigger)) activeTrigger.focus();
      activeTrigger = null;
    }

    if (close) close.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) { if (event.target === dialog) closeDialog(); });
    document.addEventListener('click', function (event) {
      var trigger = event.target instanceof Element ? event.target.closest('[data-gd-quick-view]') : null;
      if (!trigger) return;
      event.preventDefault();
      var handle = trigger.dataset.productHandle;
      if (!handle) return;
      activeTrigger = trigger;
      if (status) { status.hidden = false; status.textContent = 'Carregando produto…'; }
      if (body) body.hidden = true;
      if (errorNode) errorNode.hidden = true;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      request(rootUrl + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (product) {
          var variants = product.variants || [];
          var variant = variants.find(function (item) { return item.available; }) || variants[0];
          var image = dialog.querySelector('[data-gd-quick-view-image]');
          var title = dialog.querySelector('[data-gd-quick-view-title]');
          var type = dialog.querySelector('[data-gd-quick-view-type]');
          var price = dialog.querySelector('[data-gd-quick-view-price]');
          var description = dialog.querySelector('[data-gd-quick-view-description]');
          var link = dialog.querySelector('[data-gd-quick-view-link]');
          var plainDescription = new DOMParser().parseFromString(product.description || '', 'text/html').body.textContent.trim();
          if (image) {
            image.src = product.featured_image || '';
            image.alt = product.title || 'Produto';
            image.hidden = !product.featured_image;
          }
          if (title) title.textContent = product.title || 'Produto';
          if (type) type.textContent = product.type || 'Produto';
          if (price) price.textContent = variant ? money(Number(variant.price) || 0) : '';
          if (description) description.textContent = plainDescription.slice(0, 220);
          if (link) link.href = product.url || (rootUrl + 'products/' + handle);
          if (add) {
            add.dataset.variantId = variant ? String(variant.id) : '';
            add.disabled = !variant || !variant.available;
            add.textContent = variant && variant.available ? 'Adicionar ao carrinho' : 'Indisponível';
          }
          if (status) status.hidden = true;
          if (body) body.hidden = false;
        })
        .catch(function () {
          if (status) status.textContent = 'Não foi possível carregar este produto.';
        });
    });
    if (add) add.addEventListener('click', function () {
      if (!add.dataset.variantId) return;
      var original = add.textContent;
      add.disabled = true;
      add.textContent = 'Adicionando…';
      if (errorNode) errorNode.hidden = true;
      gdCart.add([{ id: Number(add.dataset.variantId), quantity: 1 }]).then(function (cart) {
        setCartCount(cart.item_count);
        updateMobileCartPreview(cart);
        closeDialog();
        afterAdd(add, 'Produto adicionado ao carrinho.', cart);
      }).catch(function (error) {
        if (errorNode) { errorNode.textContent = error.message; errorNode.hidden = false; }
      }).finally(function () { add.disabled = false; add.textContent = original; });
    });
  }

  var recentlyViewedStorageKey = 'gd:recently-viewed';

  function readRecentlyViewed() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(recentlyViewedStorageKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (item) { return item && item.handle; }) : [];
    } catch (error) {
      return [];
    }
  }

  function initRecentlyViewed() {
    var section = document.querySelector('[data-gd-recently-viewed]');
    if (!section) return;
    if (document.body && document.body.dataset.gdConsentEnabled === 'true') {
      if (!section.dataset.gdConsentEventBound) {
        section.dataset.gdConsentEventBound = 'true';
        document.addEventListener('gd:consent:updated', function () { initRecentlyViewed(); });
      }
      section.hidden = true;
      if (document.body.dataset.gdConsentResolved !== 'true' || document.body.dataset.gdPreferencesConsent !== 'true') {
        section.dataset.gdBound = '';
        var recentGrid = section.querySelector('[data-gd-recent-grid]');
        if (recentGrid) recentGrid.textContent = '';
        return;
      }
      section.hidden = false;
    }
    if (section.dataset.gdBound) return;
    section.dataset.gdBound = 'true';
    var history = readRecentlyViewed();
    var current = document.querySelector('[data-gd-recent-product]');
    var currentHandle = current && current.dataset.gdProductHandle;
    if (currentHandle) {
      var snapshot = {
        id: String(current.dataset.gdProductId || ''),
        handle: currentHandle,
        title: current.dataset.gdProductTitle || 'Produto',
        category: current.dataset.gdProductType || 'Cuidado capilar',
        url: current.dataset.gdProductUrl || (rootUrl + 'products/' + currentHandle),
        image: current.dataset.gdProductImage || '',
        variantId: current.dataset.gdProductVariantId || '',
        price: Number(current.dataset.gdProductPrice) || 0,
        comparePrice: Number(current.dataset.gdProductComparePrice) || 0,
        available: current.dataset.gdProductAvailable !== 'false'
      };
      history = [snapshot].concat(history.filter(function (item) { return item.handle !== currentHandle; })).slice(0, 12);
      try { window.localStorage.setItem(recentlyViewedStorageKey, JSON.stringify(history)); } catch (error) { /* Browsing history remains optional. */ }
    }
    var visible = history.filter(function (item) { return item.handle !== currentHandle; }).slice(0, Number(section.dataset.gdRecentLimit) || 4);
    var grid = section.querySelector('[data-gd-recent-grid]');
    var empty = section.querySelector('[data-gd-recent-empty]');
    if (!visible.length || !grid) { section.hidden = true; return; }
    Promise.all(visible.map(function (item) {
      return window.gdRecentCard(item, rootUrl, hydrateFavorite, createFavoriteCard);
    })).then(function (cards) {
      grid.textContent = '';
      cards.forEach(function (card) { grid.appendChild(card); });
      bindAddForms(grid);
      initProductCards(grid);
      initAmbientMedia(grid);
      syncFavoriteCards(grid);
      initNotifyDialogs(grid);
      initQuickView();
      if (empty) empty.hidden = true;
      section.hidden = false;
    });
  }

  function initBulkAdd(scope) {
    (scope || document).querySelectorAll('[data-gd-bulk-add]').forEach(function (form) {
      if (form.dataset.gdBound) return;
      form.dataset.gdBound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var selected = Array.prototype.slice.call(form.querySelectorAll('input[type="checkbox"]:checked:not(:disabled)'));
        var button = form.querySelector('[type="submit"]');
        var message = form.querySelector('[data-gd-bulk-message]');
        if (!selected.length) {
          if (message) { message.textContent = 'Selecione ao menos um item disponível.'; message.hidden = false; }
          return;
        }
        var original = button.textContent;
        button.disabled = true;
        button.textContent = 'Adicionando…';
        if (message) message.hidden = true;
        gdCart.add(selected.map(function (input) { return { id: Number(input.value), quantity: 1 }; })).then(function (cart) {
            setCartCount(cart.item_count);
            updateMobileCartPreview(cart);
            trackCommerceEvent('gd_add_to_cart', { source: 'bundle' });
            var policy = document.body && document.body.dataset.gdAfterAdd ? document.body.dataset.gdAfterAdd : 'toast';
            if (message && policy !== 'none' && !cart.gdWasEmptyBeforeAdd) { message.textContent = 'Itens selecionados adicionados ao carrinho.'; message.hidden = false; }
            afterAdd(button, 'Itens selecionados adicionados ao carrinho.', cart);
          }).catch(function (error) {
          if (message) { message.textContent = error.message; message.hidden = false; }
        }).finally(function () { button.disabled = false; button.textContent = original; });
      });
    });
  }

  function initCartPage() {
    document.querySelectorAll('[data-gd-cart-page-coupon]').forEach(function (form) {
      if (form.dataset.gdBound) return;
      form.dataset.gdBound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = form.querySelector('input[name="discount"]');
        var code = input ? input.value.trim() : '';
        if (!code) { showToast('Digite o código do cupom.'); return; }
        window.location.href = rootUrl + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(rootUrl + 'cart');
      });
    });
    function updateCartPageSavings(cart) {
      var shopifyDiscount = Math.max(0, Number(cart.total_discount || 0));
      var priceSavings = (cart.items || []).reduce(function (total, item) {
        var line = Array.prototype.find.call(document.querySelectorAll('[data-gd-cart-page] [data-gd-line]'), function (candidate) {
          return candidate.dataset.gdLine === item.key;
        });
        if (!line || line.dataset.gdManagedGift === 'true') return total;
        var compareLinePrice = Number(line.dataset.gdCompareAt || 0) * Number(item.quantity || 0);
        return total + Math.max(0, compareLinePrice - Number(item.original_line_price || 0));
      }, 0);
      var totalSavings = priceSavings + shopifyDiscount;
      var discountRow = document.querySelector('[data-gd-shopify-discount]');
      var discountValue = document.querySelector('[data-gd-shopify-discount-value]');
      if (discountRow) discountRow.hidden = shopifyDiscount <= 0;
      if (discountValue) discountValue.textContent = '− ' + money(shopifyDiscount, cart.currency);
      var savingsRow = document.querySelector('[data-gd-total-savings]');
      var savingsValue = document.querySelector('[data-gd-total-savings-value]');
      if (savingsRow) savingsRow.hidden = totalSavings <= 0;
      if (savingsValue) savingsValue.textContent = money(totalSavings, cart.currency);
    }
    document.querySelectorAll('[data-gd-cart-page] [data-gd-line]').forEach(function (line) {
      if (line.dataset.gdBound) return;
      line.dataset.gdBound = 'true';
      var input = line.querySelector('[data-gd-qty-input]');
      var errorNode = line.querySelector('[data-gd-line-error]');
      function update(quantity) {
        line.setAttribute('aria-busy', 'true');
        changeCart(line.dataset.gdLine, Math.max(0, quantity)).then(function (cart) {
          setCartCount(cart.item_count); updateCommercialProgress(cart);
          var item = cart.items.find(function (entry) { return entry.key === line.dataset.gdLine; });
          if (!item) { line.remove(); if (!cart.item_count) window.location.reload(); return; }
          input.value = item.quantity;
          line.querySelector('[data-gd-line-price]').textContent = money(item.final_line_price, cart.currency);
           var compareLine = line.querySelector('[data-gd-line-compare]');
           if (compareLine) compareLine.textContent = money(Number(line.dataset.gdCompareAt || 0) * Number(item.quantity || 0), cart.currency);
          var total = document.querySelector('[data-gd-cart-total]');
           var page = document.querySelector('[data-gd-cart-page]');
           if (page) page.dataset.gdCartBaseTotal = String(cart.total_price);
           if (window.GDShippingUI) window.GDShippingUI.updateSummaries();
           updateCartPageSavings(cart);
        }).catch(function (error) { errorNode.textContent = error.message; errorNode.hidden = false; }).finally(function () { line.removeAttribute('aria-busy'); });
      }
       if (input) {
         line.querySelectorAll('[data-gd-qty]').forEach(function (button) { button.addEventListener('click', function () { update(Number(input.value) + Number(button.dataset.gdQty)); }); });
         input.addEventListener('change', function () { update(Number(input.value)); });
       }
       var remove = line.querySelector('[data-gd-remove]');
       if (remove) remove.addEventListener('click', function () { update(0); });
    });
  }

  function initShippingCalculators(scope) {
    /* gd-shipping.js owns native shipping and brazilianProvinceForPostalCode. */
    if (window.GDShippingUI) window.GDShippingUI.init(scope || document, {
      rootUrl: rootUrl,
      request: request,
      money: money
    });
  }

  function appendUniqueCollectionCards(grid, incomingGrid) {
    var seen = new Set(Array.prototype.map.call(grid.querySelectorAll('[data-gd-product-card]'), function (card) {
      return String(card.dataset.gdProductId || '');
    }));
    var added = 0;
    Array.prototype.forEach.call(incomingGrid.querySelectorAll('[data-gd-product-card]'), function (card) {
      var id = String(card.dataset.gdProductId || '');
      if (!id || seen.has(id)) return;
      seen.add(id);
      grid.appendChild(card);
      added += 1;
    });
    return added;
  }

  function initCollection(scope) {
    (scope || document).querySelectorAll('[data-gd-collection]').forEach(function (section) {
      if (section.dataset.gdCollectionBound) return;
      section.dataset.gdCollectionBound = 'true';
      var filters = section.querySelector('[data-gd-filters]');
      var opener = section.querySelector('[data-gd-filter-open]');
      var closer = section.querySelector('[data-gd-filter-close]');
      var backdrop = section.querySelector('[data-gd-filter-backdrop]');
      var lastTrigger;
      var initialFilterValues = Math.max(3, Math.min(12, Number(section.dataset.gdFilterInitialValues) || 5));
      function syncClosedFilterAccessibility() {
        if (!filters) return;
        var mobile = window.matchMedia('(max-width: 767px)').matches;
        if (!mobile && filters.classList.contains('is-open')) {
          filters.classList.remove('is-open');
          document.body.classList.remove('gd-filters-open');
          if (backdrop) backdrop.hidden = true;
          if (opener) opener.setAttribute('aria-expanded', 'false');
        }
        var shouldHide = mobile && !filters.classList.contains('is-open');
        filters.setAttribute('aria-hidden', String(shouldHide));
        filters.inert = shouldHide;
      }
      syncClosedFilterAccessibility();
      window.addEventListener('resize', syncClosedFilterAccessibility);
      section.querySelectorAll('[data-gd-filter-group]').forEach(function (group) {
        var summary = group.querySelector('summary');
        var list = group.querySelector('ul');
        if (!summary || !list) return;
        if (/tamanho/i.test(group.dataset.gdFilterLabel || summary.textContent || '')) {
          Array.prototype.slice.call(list.children).sort(function (a, b) {
            function sizeValue(node) {
              var value = (node.dataset.gdFilterOptionLabel || node.textContent || '').trim().toLocaleLowerCase('pt-BR').replace(',', '.');
              var number = parseFloat(value.replace(/[^\d.]/g, '')) || Number.MAX_SAFE_INTEGER;
              var unit = value.includes('ml') ? 0 : (value.includes('kg') || /\bg\b/.test(value) ? 1 : 2);
              return { unit: unit, number: value.includes('kg') ? number * 1000 : number, label: value };
            }
            var left = sizeValue(a);
            var right = sizeValue(b);
            return left.unit - right.unit || left.number - right.number || left.label.localeCompare(right.label, 'pt-BR');
          }).forEach(function (item) { list.appendChild(item); });
        }
        var options = Array.prototype.slice.call(list.querySelectorAll('[data-gd-filter-option]'));
        var overflowOptions = options.filter(function (option, index) {
          var checked = option.querySelector('input:checked');
          return index >= initialFilterValues && !checked;
        });
        var valuesToggle = group.querySelector('[data-gd-filter-values-toggle]');
        if (valuesToggle && overflowOptions.length) {
          valuesToggle.hidden = false;
          valuesToggle.textContent = 'Carregar mais opções (' + overflowOptions.length + ')';
          overflowOptions.forEach(function (option) { option.hidden = true; });
          valuesToggle.addEventListener('click', function () {
            var expanded = valuesToggle.getAttribute('aria-expanded') === 'true';
            valuesToggle.setAttribute('aria-expanded', String(!expanded));
            overflowOptions.forEach(function (option) { option.hidden = expanded; });
            valuesToggle.textContent = expanded ? 'Carregar mais opções (' + overflowOptions.length + ')' : 'Mostrar menos';
          });
        }
      });
      var moreFilters = section.querySelector('[data-gd-more-filters]');
      var extraFilters = Array.prototype.slice.call(section.querySelectorAll('[data-gd-extra-filter]'));
      if (moreFilters && extraFilters.length) {
        moreFilters.setAttribute('aria-expanded', 'false');
        moreFilters.addEventListener('click', function () {
          var expanded = moreFilters.getAttribute('aria-expanded') === 'true';
          moreFilters.setAttribute('aria-expanded', String(!expanded));
          extraFilters.forEach(function (filter) { filter.hidden = expanded; });
          moreFilters.textContent = expanded ? 'Mais filtros' : 'Menos filtros';
        });
      }
      function setFilters(open) {
        if (!filters) return;
        filters.classList.toggle('is-open', open);
        if (backdrop) backdrop.hidden = !open;
        document.body.classList.toggle('gd-filters-open', open);
        if (opener) opener.setAttribute('aria-expanded', String(open));
        syncClosedFilterAccessibility();
        if (open) { lastTrigger = document.activeElement; var first = filters.querySelector('button, input, select'); if (first) first.focus(); }
        else if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      }
      if (opener) opener.addEventListener('click', function () { setFilters(true); });
      if (closer) closer.addEventListener('click', function () { setFilters(false); });
      if (backdrop) backdrop.addEventListener('click', function () { setFilters(false); });
      document.addEventListener('keydown', function (event) {
        if (!filters || !filters.classList.contains('is-open')) return;
        if (event.key === 'Escape') setFilters(false);
        if (event.key === 'Tab') {
          var focusable = filters.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href]');
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      var loadedCollectionPages = new Set();
      function load(url, append) {
        var results = section.querySelector('[data-gd-collection-results]');
        if (!results) return;
        var sectionId = section.dataset.gdSectionId || section.dataset.sectionId || '';
        results.setAttribute('aria-busy', 'true');
        results.classList.add('gd-is-loading');
        return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId), { headers: { Accept: 'text/html' } })
          .then(function (response) { if (!response.ok) throw new Error(); return response.text(); })
          .then(function (html) {
            var incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gd-collection-results]');
            if (!incoming) throw new Error();
            if (append) {
              var grid = results.querySelector('.gd-product-grid');
              var newGrid = incoming.querySelector('.gd-product-grid');
              var added = grid && newGrid ? appendUniqueCollectionCards(grid, newGrid) : 0;
              if (added) {
                initProductCards(grid);
                syncFavoriteCards(grid);
                bindAddForms(grid);
                initAmbientMedia(grid);
              }
              var oldMore = results.querySelector('[data-gd-load-more]'); var newMore = incoming.querySelector('[data-gd-load-more]');
              if (oldMore) {
                var followingUrl = newMore && newMore.dataset.gdNextUrl || '';
                if (!added || followingUrl === url || loadedCollectionPages.has(followingUrl)) followingUrl = '';
                oldMore.dataset.gdNextUrl = followingUrl;
                oldMore.hidden = !oldMore.dataset.gdNextUrl;
                oldMore.setAttribute('aria-busy', 'false');
              }
              loadedCollectionPages.add(url);
            } else {
              section.outerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gd-collection]').outerHTML;
              initCollection(document); initSortPickers(document); initProductCards(document); initAmbientMedia(document); syncFavoriteCards(document); bindAddForms(document);
            }
            if (!append) window.history.pushState({}, '', url);
             return !append || added > 0;
          }).catch(function () {
            results.insertAdjacentHTML('afterbegin', '<p class="gd-form-error" role="alert">Não foi possível atualizar os produtos. <button type="button" class="gd-text-link" data-gd-collection-retry>Tentar novamente</button></p>');
            var retry = results.querySelector('[data-gd-collection-retry]'); if (retry) retry.addEventListener('click', function () { retry.parentNode.remove(); load(url, append); });
            return false;
          }).finally(function () { results.removeAttribute('aria-busy'); results.classList.remove('gd-is-loading'); });
      }
      section.querySelectorAll('[data-gd-collection-form]').forEach(function (form) {
        form.addEventListener('submit', function (event) { event.preventDefault(); var url = form.action + '?' + new URLSearchParams(new FormData(form)).toString(); setFilters(false); load(url, false); });
      });
      var filterForm = filters && filters.querySelector('[data-gd-collection-form]');
      if (filterForm) {
        var countRequest = 0;
        filterForm.addEventListener('change', function () {
          var requestId = ++countRequest;
          var sectionId = section.dataset.gdSectionId || section.dataset.sectionId || '';
          var url = filterForm.action + '?' + new URLSearchParams(new FormData(filterForm)).toString();
          var count = filterForm.querySelector('[data-gd-filter-live-count]');
          if (count) count.textContent = '…';
          fetch(url + '&section_id=' + encodeURIComponent(sectionId), { headers: { Accept: 'text/html' } })
            .then(function (response) { if (!response.ok) throw new Error(); return response.text(); })
            .then(function (html) {
              if (requestId !== countRequest) return;
              var incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gd-collection]');
              var value = incoming && incoming.dataset.gdProductCount;
              if (count && value != null) count.textContent = value;
            })
            .catch(function () { if (requestId === countRequest && count) count.textContent = '—'; });
        });
      }
      section.querySelectorAll('[data-gd-filter-chip]').forEach(function (link) { link.addEventListener('click', function (event) { event.preventDefault(); load(link.href, false); }); });
      section.querySelectorAll('[data-gd-page-link]').forEach(function (link) { link.addEventListener('click', function (event) { event.preventDefault(); load(link.href, false); }); });
      var more = section.querySelector('[data-gd-load-more]');
      if (more) {
        var loadingMore = false;
        var moreObserver = null;
        more.hidden = !more.dataset.gdNextUrl;
        function setMoreLoading(isLoading) {
          more.setAttribute('aria-busy', String(isLoading));
          var status = more.querySelector('.gd-load-more__status');
          if (status) status.textContent = isLoading ? 'Carregando mais produtos…' : '';
        }
        function loadNextPage() {
          if (loadingMore || !more.dataset.gdNextUrl) return Promise.resolve();
          if (loadedCollectionPages.has(more.dataset.gdNextUrl)) {
            more.dataset.gdNextUrl = '';
            more.hidden = true;
            if (moreObserver) moreObserver.disconnect();
            return Promise.resolve();
          }
          loadingMore = true;
          setMoreLoading(true);
          var nextUrl = more.dataset.gdNextUrl;
          return load(nextUrl, true).then(function (loaded) {
            if (loaded && more.dataset.gdNextUrl) window.setTimeout(checkMorePosition, 650);
          }).finally(function () {
            loadingMore = false;
            if (!more.isConnected) return;
            more.hidden = !more.dataset.gdNextUrl;
            setMoreLoading(false);
            if (!more.dataset.gdNextUrl && moreObserver) moreObserver.disconnect();
          });
        }
        function checkMorePosition() {
          if (!more.hidden && more.getBoundingClientRect().top - window.innerHeight < 240) loadNextPage();
        }
        if ('IntersectionObserver' in window) {
          moreObserver = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            loadNextPage();
          }, { rootMargin: '0px 0px 240px' });
          moreObserver.observe(more);
        } else {
          window.addEventListener('scroll', checkMorePosition, { passive: true });
          window.addEventListener('resize', checkMorePosition);
          checkMorePosition();
        }
        var moreButton = more.querySelector('[data-gd-load-more-button]');
        bindLoadMoreButton(moreButton, loadNextPage);
      }
    });
  }

  function bindLoadMoreButton(button, loadNextPage) {
    if (!button) return;
    button.addEventListener('click', function (event) {
      event.preventDefault();
      loadNextPage();
    });
  }

  function initRecommendations() {
    document.querySelectorAll('[data-gd-recommendations]').forEach(function (section) {
      if (section.hasAttribute('data-gd-complementary-fallback') && document.querySelector('[data-gd-also-bought]')) {
        section.remove();
        return;
      }
      if (section.dataset.gdLoaded || !section.dataset.url) return;
      section.dataset.gdLoaded = 'true';
      fetch(section.dataset.url).then(function (response) { if (!response.ok) throw new Error(); return response.text(); }).then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var incoming = documentFragment.querySelector('[data-gd-recommendations]');
        if (incoming && incoming.innerHTML.trim()) { section.innerHTML = incoming.innerHTML; initProductCards(section); bindAddForms(section); initAmbientMedia(section); syncFavoriteCards(section); } else { section.remove(); }
      }).catch(function () { section.remove(); });
    });
  }

  function initAmbientMedia(scope) {
    if (!window.matchMedia('(hover: none)').matches) return;
    var media = (scope || document).querySelectorAll('[data-gd-ambient-media]');
    if (!media.length) return;
    if ('IntersectionObserver' in window && !ambientObserver) {
      ambientObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.dataset.gdAmbientVisible = String(entry.isIntersecting);
          if (entry.target.dataset.gdAmbientPressed !== 'true') entry.target.classList.toggle('is-ambient', entry.isIntersecting);
        });
      }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
    }
    media.forEach(function (element) {
      if (element.dataset.gdAmbientBound) return;
      element.dataset.gdAmbientBound = 'true';
      if (ambientObserver) ambientObserver.observe(element);
      element.addEventListener('touchstart', function () {
        element.dataset.gdAmbientPressed = 'true';
        element.classList.add('is-ambient');
      }, { passive: true });
      ['touchend', 'touchcancel'].forEach(function (eventName) {
        element.addEventListener(eventName, function () {
          element.dataset.gdAmbientPressed = 'false';
          element.classList.toggle('is-ambient', element.dataset.gdAmbientVisible === 'true');
        }, { passive: true });
      });
    });
  }

  function cleanupAmbientMedia(scope) {
    if (!scope) return;
    var nodes = [];
    if (scope.matches && scope.matches('[data-gd-ambient-media]')) nodes.push(scope);
    scope.querySelectorAll('[data-gd-ambient-media]').forEach(function (node) { nodes.push(node); });
    nodes.forEach(function (element) {
      if (ambientObserver) ambientObserver.unobserve(element);
      element.classList.remove('is-ambient');
      delete element.dataset.gdAmbientBound;
      delete element.dataset.gdAmbientVisible;
      delete element.dataset.gdAmbientPressed;
    });
  }

  function initCollectionShowcases(scope) {
    (scope || document).querySelectorAll('[data-gd-collection-showcase]').forEach(function (section) {
      if (section.dataset.gdShowcaseBound) return;
      section.dataset.gdShowcaseBound = 'true';
      var track = section.querySelector('[data-gd-showcase-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-gd-showcase-card]'));
      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-gd-showcase-dot]'));
      function setCurrent(index) {
        dots.forEach(function (dot, dotIndex) { dot.setAttribute('aria-current', String(dotIndex === index)); });
      }
      function goTo(index) {
        var bounded = Math.max(0, Math.min(cards.length - 1, index));
        if (cards[bounded]) cards[bounded].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        setCurrent(bounded);
      }
      dots.forEach(function (dot) { dot.addEventListener('click', function () { goTo(Number(dot.dataset.gdShowcaseDot)); }); });
      var previous = section.querySelector('[data-gd-showcase-prev]');
      var next = section.querySelector('[data-gd-showcase-next]');
      if (previous) previous.addEventListener('click', function () {
        var current = dots.findIndex(function (dot) { return dot.getAttribute('aria-current') === 'true'; });
        goTo(current - 1);
      });
      if (next) next.addEventListener('click', function () {
        var current = dots.findIndex(function (dot) { return dot.getAttribute('aria-current') === 'true'; });
        goTo(current + 1);
      });
      track.addEventListener('scroll', function () {
        var nearest = 0;
        var distance = Infinity;
        cards.forEach(function (card, index) {
          var cardDistance = Math.abs(card.offsetLeft - track.scrollLeft - track.offsetLeft);
          if (cardDistance < distance) { distance = cardDistance; nearest = index; }
        });
        setCurrent(nearest);
      }, { passive: true });
    });
  }

  function initCategoryDropdown(scope) {
    (scope || document).querySelectorAll('[data-gd-category-toggle]').forEach(function (toggle) {
      if (toggle.dataset.gdCategoryBound) return;
      var wrapper = toggle.closest('.gd-category-nav');
      var panel = wrapper && wrapper.querySelector('[data-gd-category-panel]');
      if (!panel) return;
      toggle.dataset.gdCategoryBound = 'true';
      function setOpen(open) {
        toggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      }
      toggle.addEventListener('click', function () { setOpen(toggle.getAttribute('aria-expanded') !== 'true'); });
      document.addEventListener('click', function (event) {
        if (!wrapper.contains(event.target)) setOpen(false);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  function initScrollHints(scope) {
    (scope || document).querySelectorAll('[data-gd-scroll-hint-track]').forEach(function (track) {
      if (track.dataset.gdScrollHintBound) return;
      var hint = track.parentElement && track.parentElement.querySelector('[data-gd-scroll-hint]');
      if (!hint) return;
      track.dataset.gdScrollHintBound = 'true';
      function dismissHint() { hint.classList.add('is-hidden'); }
      function updateHint() {
        hint.classList.toggle('is-hidden', track.scrollWidth <= track.clientWidth + 4 || track.scrollLeft > 4);
      }
      track.addEventListener('scroll', function () {
        if (track.scrollLeft > 4) dismissHint();
      }, { passive: true });
      track.addEventListener('pointerdown', dismissHint, { passive: true });
      track.addEventListener('touchstart', dismissHint, { passive: true });
      if (hint.matches('button')) {
        hint.addEventListener('click', function () {
          dismissHint();
          track.scrollBy({ left: Math.max(280, track.clientWidth * .7), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      }
      updateHint();
      window.addEventListener('resize', updateHint);
    });
  }

  function initNotifyDialogs(scope) {
    (scope || document).querySelectorAll('[data-gd-notify-open]').forEach(function (button) {
      if (button.dataset.gdNotifyBound) return;
      var dialog = document.getElementById(button.dataset.gdNotifyOpen || '');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      button.dataset.gdNotifyBound = 'true';
      button.addEventListener('click', function () {
        dialog.showModal();
        var email = dialog.querySelector('input[type="email"]');
        if (email) window.setTimeout(function () { email.focus(); }, 0);
      });
      var close = dialog.querySelector('[data-gd-notify-close]');
      if (close) close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  function dropdownAvailableHeight(panelTop, viewportBottom, blockerTops) {
    var bottom = viewportBottom;
    blockerTops.forEach(function (top) { if (top > panelTop && top < bottom) bottom = top; });
    return Math.max(0, Math.floor(bottom - panelTop - 12));
  }

  function initPrimaryDropdown(scope) {
    (scope || document).querySelectorAll('[data-gd-primary-dropdown]').forEach(function (wrapper) {
      if (wrapper.dataset.gdPrimaryBound) return;
      var toggle = wrapper.querySelector('[data-gd-primary-toggle]');
      var panel = wrapper.querySelector('[data-gd-primary-panel]');
      if (!toggle || !panel) return;
      wrapper.dataset.gdPrimaryBound = 'true';
      var boundsFrame = null;
      function fitPanel() {
        boundsFrame = null;
        if (panel.hidden) return;
        var viewport = window.visualViewport;
        var viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        var blockers = [];
        document.querySelectorAll('[data-gd-mobile-cart-preview]:not([hidden]), .gd-cart-preview-slide:not(.is-dismissed)').forEach(function (bar) {
          var rect = bar.getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0) blockers.push(rect.top);
        });
        var available = dropdownAvailableHeight(panel.getBoundingClientRect().top, viewportBottom, blockers);
        panel.style.setProperty('--gd-dropdown-available-height', available + 'px');
      }
      function queueFit() {
        if (panel.hidden || boundsFrame !== null) return;
        boundsFrame = window.requestAnimationFrame(fitPanel);
      }
      function setOpen(open) {
        toggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
        if (open) {
          panel.scrollTop = 0;
          fitPanel();
        }
      }
      window.addEventListener('resize', queueFit, { passive: true });
      window.addEventListener('scroll', queueFit, { passive: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', queueFit, { passive: true });
        window.visualViewport.addEventListener('scroll', queueFit, { passive: true });
      }
      document.addEventListener('gd:cart:updated', queueFit);
      if (window.ResizeObserver) {
        var boundsObserver = new ResizeObserver(queueFit);
        boundsObserver.observe(wrapper);
        document.querySelectorAll('[data-gd-mobile-cart-preview], .gd-cart-preview-slide').forEach(function (bar) { boundsObserver.observe(bar); });
      }
      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });
      document.addEventListener('pointerdown', function (event) {
        if (!wrapper.contains(event.target)) setOpen(false);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
      panel.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { setOpen(false); });
      });
    });
  }

  function initLookbooks(scope) {
    (scope || document).querySelectorAll('[data-gd-lookbook]').forEach(function (lookbook) {
      if (lookbook.dataset.gdLookbookBound) return;
      var pins = Array.prototype.slice.call(lookbook.querySelectorAll('[data-gd-lookbook-pin]'));
      var cards = Array.prototype.slice.call(lookbook.querySelectorAll('[data-gd-lookbook-card]'));
      var dialog = lookbook.querySelector('[data-gd-lookbook-dialog]');
      if (!pins.length || !cards.length || !dialog) return;
      var closeButton = dialog.querySelector('[data-gd-lookbook-close]');
      var status = dialog.querySelector('[data-gd-lookbook-status]');
      var body = dialog.querySelector('[data-gd-lookbook-body]');
      var image = dialog.querySelector('[data-gd-lookbook-image]');
      var title = dialog.querySelector('[data-gd-lookbook-title]');
      var type = dialog.querySelector('[data-gd-lookbook-type]');
      var price = dialog.querySelector('[data-gd-lookbook-price]');
      var description = dialog.querySelector('[data-gd-lookbook-description]');
      var variantWrap = dialog.querySelector('[data-gd-lookbook-variants-wrap]');
      var variantSelect = dialog.querySelector('[data-gd-lookbook-variants]');
      var quantity = dialog.querySelector('[data-gd-lookbook-quantity]');
      var minus = dialog.querySelector('[data-gd-lookbook-minus]');
      var plus = dialog.querySelector('[data-gd-lookbook-plus]');
      var add = dialog.querySelector('[data-gd-lookbook-add]');
      var link = dialog.querySelector('[data-gd-lookbook-link]');
      var errorNode = dialog.querySelector('[data-gd-lookbook-error]');
      var variants = [];
      var activeTrigger = null;
      lookbook.dataset.gdLookbookBound = 'true';

      function selectPin(id, scrollCard, showTooltip) {
        pins.forEach(function (pin) {
          var active = pin.dataset.gdLookbookPin === id;
          pin.setAttribute('aria-pressed', String(active));
          var wrap = pin.closest('[data-gd-lookbook-pin-wrap]');
          if (wrap) {
            wrap.classList.toggle('is-selected', active);
            wrap.classList.toggle('is-active', active && Boolean(showTooltip));
          }
        });
        cards.forEach(function (card) {
          var active = card.dataset.gdLookbookCard === id;
          card.classList.toggle('is-active', active);
          var row = card.closest('.gd-lookbook__product-row');
          if (row) row.classList.toggle('is-active', active);
          if (active && scrollCard && window.matchMedia('(max-width: 899px)').matches) {
            var track = card.closest('.gd-lookbook__products');
            if (track) {
              var target = row || card;
              var centeredLeft = target.offsetLeft - (track.clientWidth - target.clientWidth) / 2;
              track.scrollTo({ left: centeredLeft, behavior: 'smooth' });
            }
          }
        });
      }

      function selectedVariant() {
        var id = variantSelect ? String(variantSelect.value) : '';
        return variants.find(function (variant) { return String(variant.id) === id; }) || variants[0];
      }

      function updateVariant() {
        var variant = selectedVariant();
        if (price) price.textContent = variant ? money(Number(variant.price) || 0) : '';
        if (add) {
          add.dataset.variantId = variant ? String(variant.id) : '';
          add.disabled = !variant || !variant.available;
          add.textContent = variant && variant.available ? 'Adicionar ao carrinho' : 'Indisponível';
        }
      }

      function closeDialog() {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      }

      function openProduct(trigger) {
        var handle = trigger.dataset.productHandle;
        if (!handle) return;
        activeTrigger = trigger;
        if (status) { status.hidden = false; status.textContent = 'Carregando produto…'; }
        if (body) body.hidden = true;
        if (errorNode) errorNode.hidden = true;
        if (quantity) quantity.value = '1';
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        request(rootUrl + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (product) {
            variants = product.variants || [];
            if (image) {
              image.src = product.featured_image || '';
              image.alt = product.title || 'Produto';
              image.hidden = !product.featured_image;
            }
            if (title) title.textContent = product.title || 'Produto';
            if (type) type.textContent = product.type || 'Cuidado capilar';
            if (description) {
              description.textContent = new DOMParser().parseFromString(product.description || '', 'text/html').body.textContent.trim().slice(0, 260);
            }
            if (link) link.href = product.url || (rootUrl + 'products/' + handle);
            if (variantSelect) {
              variantSelect.innerHTML = '';
              variants.forEach(function (variant) {
                var option = document.createElement('option');
                option.value = String(variant.id);
                option.textContent = variant.title + (variant.available ? '' : ' — Indisponível');
                option.disabled = !variant.available;
                variantSelect.appendChild(option);
              });
              var available = variants.find(function (variant) { return variant.available; }) || variants[0];
              if (available) variantSelect.value = String(available.id);
            }
            if (variantWrap) {
              var hasRealVariantChoice = variants.length > 1
                && variants.some(function (variant) {
                  return variant.title && variant.title !== 'Default Title';
                });
              variantWrap.hidden = !hasRealVariantChoice;
            }
            updateVariant();
            if (status) status.hidden = true;
            if (body) body.hidden = false;
          })
          .catch(function () {
            if (status) status.textContent = 'Não foi possível carregar este produto.';
          });
      }

      pins.forEach(function (pin) {
        pin.addEventListener('click', function () { selectPin(pin.dataset.gdLookbookPin, true, true); });
        pin.addEventListener('focus', function () { selectPin(pin.dataset.gdLookbookPin, true, true); });
        var wrap = pin.closest('[data-gd-lookbook-pin-wrap]');
        if (wrap && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          wrap.addEventListener('mouseenter', function () {
            selectPin(pin.dataset.gdLookbookPin, true, true);
          });
        }
      });
      cards.forEach(function (card) {
        card.addEventListener('focus', function () { selectPin(card.dataset.gdLookbookCard, false, false); });
        card.addEventListener('mouseenter', function () { selectPin(card.dataset.gdLookbookCard, false, false); });
      });
      lookbook.querySelectorAll('[data-gd-lookbook-direct-add]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;
          selectPin(button.dataset.gdLookbookDirectAdd, false, false);
          if (button.dataset.hasOptions === 'true') {
            openProduct(button);
            return;
          }
          var variantId = Number(button.dataset.variantId);
          if (!variantId) return;
          var original = button.textContent;
          button.disabled = true;
          button.textContent = 'Adicionando…';
          gdCart.add([{ id: variantId, quantity: 1 }]).then(function (cart) {
            setCartCount(cart.item_count);
            updateMobileCartPreview(cart);
            trackCommerceEvent('gd_add_to_cart', { source: 'lookbook' });
            afterAdd(button, 'Produto adicionado ao carrinho.', cart);
          }).catch(function (error) {
            showToast(error.message || 'Não foi possível adicionar este produto.');
          }).finally(function () {
            button.disabled = false;
            button.textContent = original;
          });
        });
      });
      lookbook.querySelectorAll('[data-gd-lookbook-open]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var cardId = trigger.dataset.gdLookbookCard;
          var pinWrap = trigger.closest('[data-gd-lookbook-pin-wrap]');
          if (cardId) selectPin(cardId, false, false);
          else if (pinWrap) selectPin(pinWrap.dataset.gdLookbookPinWrap, true, true);
          openProduct(trigger);
        });
      });
      if (variantSelect) variantSelect.addEventListener('change', updateVariant);
      if (minus) minus.addEventListener('click', function () {
        if (quantity) quantity.value = String(Math.max(1, (Number(quantity.value) || 1) - 1));
      });
      if (plus) plus.addEventListener('click', function () {
        if (quantity) quantity.value = String(Math.max(1, (Number(quantity.value) || 1) + 1));
      });
      if (closeButton) closeButton.addEventListener('click', closeDialog);
      dialog.addEventListener('click', function (event) { if (event.target === dialog) closeDialog(); });
      dialog.addEventListener('close', function () {
        if (activeTrigger && document.contains(activeTrigger)) activeTrigger.focus();
        activeTrigger = null;
      });
      if (add) add.addEventListener('click', function () {
        var variantId = Number(add.dataset.variantId);
        var amount = quantity ? Math.max(1, Number(quantity.value) || 1) : 1;
        if (!variantId) return;
        var original = add.textContent;
        add.disabled = true;
        add.textContent = 'Adicionando…';
        if (errorNode) errorNode.hidden = true;
        gdCart.add([{ id: variantId, quantity: amount }]).then(function (cart) {
          setCartCount(cart.item_count);
          updateMobileCartPreview(cart);
          trackCommerceEvent('gd_add_to_cart', { source: 'social_video' });
          closeDialog();
          afterAdd(add, 'Produto adicionado ao carrinho.', cart);
        }).catch(function (error) {
          if (errorNode) { errorNode.textContent = error.message; errorNode.hidden = false; }
        }).finally(function () {
          add.disabled = false;
          add.textContent = original;
        });
      });
    });
  }

  function initSocialVideos(scope) {
    (scope || document).querySelectorAll('[data-gd-social-videos]').forEach(function (section) {
      if (section.dataset.gdSocialVideosBound) return;
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-gd-social-video]'));
      if (!cards.length) return;
      var dots = Array.prototype.slice.call(section.closest('.gd-social-videos').querySelectorAll('[data-gd-social-video-dot]'));
      var counter = section.closest('.gd-social-videos').querySelector('[data-gd-social-video-counter]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var activeIndex = 0;
      var inViewport = false;
      section.dataset.gdSocialVideosBound = 'true';

      function refreshOrder() {
        var activeCard = cards.find(function (card) { return card.classList.contains('is-active'); });
        cards = Array.prototype.slice.call(section.querySelectorAll('[data-gd-social-video]'));
        dots = Array.prototype.slice.call(section.closest('.gd-social-videos').querySelectorAll('[data-gd-social-video-dot]'));
        if (activeCard) {
          var nextIndex = cards.indexOf(activeCard);
          if (nextIndex >= 0) activeIndex = nextIndex;
        }
        dots.forEach(function (dot, dotIndex) {
          var selected = dotIndex === activeIndex;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-selected', String(selected));
          dot.tabIndex = selected ? 0 : -1;
        });
        if (counter) counter.textContent = (activeIndex + 1) + '/' + cards.length;
      }

      function updateControl(card) {
        var video = card.querySelector('video');
        var control = card.querySelector('[data-gd-social-video-control]');
        if (!video || !control) return;
        var paused = video.paused;
        control.setAttribute('aria-label', paused ? 'Reproduzir vídeo' : 'Pausar vídeo');
        control.setAttribute('aria-pressed', String(!paused));
        control.dataset.gdPlaying = String(!paused);
      }

      function updateMuteControl(card) {
        var video = card.querySelector('video');
        var muteControl = card.querySelector('[data-gd-social-video-mute]');
        if (!video || !muteControl) return;
        muteControl.setAttribute('aria-label', video.muted ? 'Ativar áudio do vídeo' : 'Silenciar vídeo');
        muteControl.setAttribute('aria-pressed', String(!video.muted));
        muteControl.dataset.gdMuted = String(video.muted);
      }

      function updateProgress(card) {
        var video = card.querySelector('video');
        var bars = Array.prototype.slice.call(card.querySelectorAll('.gd-social-video__progress span'));
        var currentProgress = video && Number.isFinite(video.duration) && video.duration > 0
          ? Math.min(1, Math.max(0, video.currentTime / video.duration))
          : 0;
        bars.forEach(function (bar, barIndex) {
          bar.classList.toggle('is-complete', barIndex < activeIndex);
          bar.classList.toggle('is-current', barIndex === activeIndex);
          bar.style.setProperty('--gd-story-progress', String(barIndex < activeIndex ? 1 : barIndex === activeIndex ? currentProgress : 0));
        });
      }

      function show(index, playActive) {
        refreshOrder();
        activeIndex = (index + cards.length) % cards.length;
        cards.forEach(function (card, cardIndex) {
          var active = cardIndex === activeIndex;
          var video = card.querySelector('video');
          card.hidden = !active;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-hidden', String(!active));
          if (video) {
            if (!active) video.pause();
            else {
              if (video.readyState > 0) video.currentTime = 0;
              if (playActive && inViewport && !document.hidden && !reducedMotion.matches) video.play().catch(function () { updateControl(card); });
            }
          }
          updateControl(card);
          updateMuteControl(card);
          updateProgress(card);
        });
        dots.forEach(function (dot, dotIndex) {
          var selected = dotIndex === activeIndex;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-selected', String(selected));
          dot.tabIndex = selected ? 0 : -1;
        });
        if (counter) counter.textContent = (activeIndex + 1) + '/' + cards.length;
      }

      function move(direction) {
        refreshOrder();
        show(activeIndex + direction, true);
      }

      cards.forEach(function (card) {
        var video = card.querySelector('video');
        var control = card.querySelector('[data-gd-social-video-control]');
        var muteControl = card.querySelector('[data-gd-social-video-mute]');
        var tapPrevious = card.querySelector('[data-gd-social-video-tap-previous]');
        var tapNext = card.querySelector('[data-gd-social-video-tap-next]');
        if (!video || !control) return;
        video.loop = false;
        control.addEventListener('click', function () {
          if (video.paused) video.play().catch(function () { updateControl(card); });
          else video.pause();
        });
        if (muteControl) {
          muteControl.addEventListener('click', function () {
            video.muted = !video.muted;
            updateMuteControl(card);
          });
        }
        video.addEventListener('play', function () { updateControl(card); });
        video.addEventListener('pause', function () { updateControl(card); });
        video.addEventListener('timeupdate', function () {
          if (card.classList.contains('is-active')) updateProgress(card);
        });
        video.addEventListener('ended', function () {
          if (card.classList.contains('is-active')) move(1);
        });
        if (tapPrevious) tapPrevious.addEventListener('click', function () { move(-1); });
        if (tapNext) tapNext.addEventListener('click', function () { move(1); });
      });
      var previous = section.querySelector('[data-gd-social-video-previous]');
      var next = section.querySelector('[data-gd-social-video-next-section]');
      if (previous) previous.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          refreshOrder();
          show(dots.indexOf(dot), true);
        });
      });
      document.addEventListener('gd:favorites:reordered', function () {
        refreshOrder();
        cards.forEach(updateProgress);
      });
      function syncPlayback() {
        var card = cards[activeIndex];
        var video = card && card.querySelector('video');
        if (!video) return;
        if (inViewport && !document.hidden && !reducedMotion.matches) {
          if (video.paused) video.play().catch(function () { updateControl(card); });
        } else {
          video.pause();
        }
      }
      show(0, false);
      if ('IntersectionObserver' in window) {
        var visibilityObserver = new IntersectionObserver(function (entries) {
          inViewport = entries[0].isIntersecting;
          syncPlayback();
        }, { threshold: 0.25 });
        visibilityObserver.observe(section);
        document.addEventListener('visibilitychange', syncPlayback);
      }
    });
  }

  function initBannerSlideshows(scope) {
    (scope || document).querySelectorAll('[data-gd-banner-slideshow]').forEach(function (section) {
      if (section.dataset.gdBannerBound) return;
      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-gd-banner-slide]'));
      if (slides.length < 2) return;
      var track = section.querySelector('.gd-banner__track');
      if (!track) return;
      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-gd-banner-dot]'));
      var previous = section.querySelector('[data-gd-banner-previous]');
      var next = section.querySelector('[data-gd-banner-next]');
      var pause = section.querySelector('[data-gd-banner-pause]');
      var activeIndex = 0;
      var timer = null;
      var paused = false;
      var gesture = null;
      var suppressClick = false;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      section.dataset.gdBannerBound = 'true';
      section.classList.add('is-draggable');

      function show(index) {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === activeIndex;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach(function (dot, dotIndex) {
          var selected = dotIndex === activeIndex;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-selected', String(selected));
          dot.tabIndex = selected ? 0 : -1;
        });
      }

      function stopTimer() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function startTimer() {
        stopTimer();
        if (paused || reducedMotion.matches || section.dataset.gdBannerAutoplay !== 'true') return;
        var speed = Number(section.dataset.gdBannerSpeed) || 5000;
        timer = window.setInterval(function () { show(activeIndex + 1); }, Math.max(speed, 3000));
      }

      function setPaused(nextPaused) {
        paused = nextPaused;
        if (pause) {
          pause.textContent = paused ? 'Continuar' : 'Pausar';
          pause.setAttribute('aria-label', paused ? 'Continuar banners' : 'Pausar banners');
          pause.setAttribute('aria-pressed', String(paused));
        }
        if (paused) stopTimer(); else startTimer();
      }

      if (previous) previous.addEventListener('click', function () { show(activeIndex - 1); startTimer(); });
      if (next) next.addEventListener('click', function () { show(activeIndex + 1); startTimer(); });
      dots.forEach(function (dot, index) { dot.addEventListener('click', function () { show(index); startTimer(); }); });
      if (pause) pause.addEventListener('click', function () { setPaused(!paused); });
      track.addEventListener('pointerdown', function (event) {
        if (event.button !== 0 || event.isPrimary === false) return;
        suppressClick = false;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, dragging: false };
      });
      window.addEventListener('pointermove', function (event) {
        if (!gesture || event.pointerId !== gesture.id) return;
        var dx = event.clientX - gesture.x;
        var dy = event.clientY - gesture.y;
        if (!gesture.dragging && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          gesture.dragging = true;
          section.classList.add('is-dragging');
          stopTimer();
        }
        if (gesture.dragging && event.pointerType === 'mouse') event.preventDefault();
      });
      function finishGesture(event) {
        if (!gesture || event.pointerId !== gesture.id) return;
        var dx = event.clientX - gesture.x;
        var dy = event.clientY - gesture.y;
        if (gesture.dragging) {
          suppressClick = true;
          window.setTimeout(function () { suppressClick = false; }, 450);
          if (event.type === 'pointerup' && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(activeIndex + (dx < 0 ? 1 : -1));
          section.classList.remove('is-dragging');
          if (event.pointerType !== 'mouse' || !section.matches(':hover')) startTimer();
        }
        gesture = null;
      }
      window.addEventListener('pointerup', finishGesture);
      window.addEventListener('pointercancel', finishGesture);
      track.addEventListener('click', function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);
      track.addEventListener('dragstart', function (event) { if (gesture) event.preventDefault(); });
      section.addEventListener('mouseenter', stopTimer);
      section.addEventListener('mouseleave', function () { if (!gesture || !gesture.dragging) startTimer(); });
      section.addEventListener('focusin', stopTimer);
      section.addEventListener('focusout', function (event) {
        if (!section.contains(event.relatedTarget)) startTimer();
      });
      show(0);
      startTimer();
    });
  }

  function initBestSellers(scope) {
    (scope || document).querySelectorAll('[data-gd-best-sellers]').forEach(function (section) {
      if (section.dataset.gdBestSellersBound) return;
      var track = section.querySelector('[data-gd-best-sellers-track]');
      if (!track) return;
      section.dataset.gdBestSellersBound = 'true';
      function scroll(direction) {
        var card = track.querySelector('.gd-best-sellers-slider__product, .gd-best-sellers-slider__feature');
        var amount = card ? card.getBoundingClientRect().width + 14 : track.clientWidth * .8;
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }
      var previous = section.querySelector('[data-gd-best-sellers-prev]');
      var next = section.querySelector('[data-gd-best-sellers-next]');
      var controls = section.querySelector('[data-gd-best-sellers-controls]');
      function updateControls() {
        if (!controls) return;
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = maxScroll <= 2;
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
      }
      if (previous) previous.addEventListener('click', function () { scroll(-1); });
      if (next) next.addEventListener('click', function () { scroll(1); });
      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
      var dragState = { active: false, startX: 0, startScrollLeft: 0, moved: false };
      function isInteractive(target) {
        return target instanceof Element && Boolean(target.closest('a, button, input, select, textarea, [role="button"]'));
      }
      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || isInteractive(event.target)) return;
        dragState = { active: true, startX: event.clientX, startScrollLeft: track.scrollLeft, moved: false };
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', function (event) {
        if (!dragState.active) return;
        var distance = event.clientX - dragState.startX;
        if (Math.abs(distance) > 4) dragState.moved = true;
        track.scrollLeft = dragState.startScrollLeft - distance;
      });
      function endDrag(event) {
        if (!dragState.active) return;
        dragState.active = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (event) {
        if (!dragState.moved) return;
        event.preventDefault();
        event.stopPropagation();
        dragState.moved = false;
      }, true);
    });
  }

  function initBackToTop() {
    function updateVisibility() {
      var visible = window.pageYOffset > 420;
      document.querySelectorAll('[data-gd-back-to-top]').forEach(function (control) {
        control.classList.toggle('is-visible', visible);
        var button = control.querySelector('[data-gd-back-to-top-button]');
        if (button) { button.tabIndex = visible ? 0 : -1; button.setAttribute('aria-hidden', String(!visible)); }
      });
    }
    if (!document.documentElement.dataset.gdBackToTopBound) {
      document.documentElement.dataset.gdBackToTopBound = 'true';
      window.addEventListener('scroll', updateVisibility, { passive: true });
    }
    document.querySelectorAll('[data-gd-back-to-top-button]').forEach(function (button) {
      if (button.dataset.gdBound) return;
      button.dataset.gdBound = 'true';
      button.addEventListener('click', function () {
        var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        window.scrollTo({ top: 0, behavior: behavior });
      });
    });
    updateVisibility();
  }

  function initCareStories(scope) {
    if (window.gdCareStoriesInit) window.gdCareStoriesInit(scope || document);
  }

  function initKitQuiz(scope) {
    if (window.GDTemplateQuiz && typeof window.GDTemplateQuiz.init === 'function') window.GDTemplateQuiz.init(scope);
  }

  function homeSearchCompact(scrollY, wasCompact, searchFocused) {
    if (searchFocused) return wasCompact;
    return scrollY > 120 || (wasCompact && scrollY > 8);
  }

  function initHeaderScroll(scope) {
    (scope || document).querySelectorAll('[data-gd-header]').forEach(function (header) {
      if (header.dataset.gdScrollBound) return;
      header.dataset.gdScrollBound = 'true';
      var lastScrollY = window.scrollY;
      var ticking = false;

      function update() {
        var currentScrollY = window.scrollY;
        var searchFocused = Boolean(document.activeElement && header.contains(document.activeElement) && document.activeElement.matches('input[type="search"]'));
        if (header.hasAttribute('data-gd-home-search')) {
          header.classList.toggle('gd-header--search-compact', homeSearchCompact(currentScrollY, header.classList.contains('gd-header--search-compact'), searchFocused));
        }
        var menuOpen = document.documentElement.classList.contains('gd-menu-open');
        var editorSelected = header.dataset.gdEditorSelected === 'true';
        var searchOpen = searchFocused || Boolean(document.querySelector('[data-gd-predictive]:not([hidden]), .gd-header__search.is-mobile-open'));
        var scrollingUp = currentScrollY < lastScrollY - 4;
        var scrollingDown = currentScrollY > lastScrollY + 4;
        if (currentScrollY <= 12 || scrollingUp || menuOpen || searchOpen || editorSelected) {
          header.classList.remove('gd-header--hidden');
        } else if (currentScrollY > 72 && scrollingDown) {
          header.classList.add('gd-header--hidden');
        }
        lastScrollY = currentScrollY;
        ticking = false;
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('shopify:section:select', function (event) {
        if (!event.target.contains(header)) return;
        header.dataset.gdEditorSelected = 'true';
        header.classList.remove('gd-header--hidden');
      });
      document.addEventListener('shopify:section:deselect', function (event) {
        if (!event.target.contains(header)) return;
        header.dataset.gdEditorSelected = 'false';
      });
      update();
    });
  }

  function initSortPickers(scope) {
    (scope || document).querySelectorAll('[data-gd-sort-picker]').forEach(function (picker) {
      if (picker.dataset.gdBound) return;
      picker.dataset.gdBound = 'true';
      var select = picker.querySelector('[data-gd-sort]');
      var trigger = picker.querySelector('[data-gd-sort-trigger]');
      var value = picker.querySelector('[data-gd-sort-value]');
      var options = picker.querySelector('[data-gd-sort-options]');
      if (!select || !trigger || !value || !options) return;

      function close(restoreFocus) {
        options.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      }

      function open() {
        options.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        var selected = options.querySelector('[aria-selected="true"]') || options.querySelector('[data-gd-sort-option]');
        if (selected) selected.focus();
      }

      var selectedOption = select.options[select.selectedIndex];
      if (selectedOption) value.textContent = selectedOption.textContent;

      trigger.addEventListener('click', function () {
        if (options.hidden) open();
        else close(false);
      });
      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        open();
      });
      options.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          close(true);
        }
      });
      options.querySelectorAll('[data-gd-sort-option]').forEach(function (option) {
        option.addEventListener('click', function () {
          select.value = option.dataset.value;
          value.textContent = option.querySelector('span').textContent;
          options.querySelectorAll('[data-gd-sort-option]').forEach(function (item) {
            item.setAttribute('aria-selected', String(item === option));
          });
          close(false);
          if (select.form) select.form.requestSubmit();
        });
      });
      document.addEventListener('pointerdown', function (event) {
        if (!picker.contains(event.target)) close(false);
      });
    });
  }

  function syncFooterLogo() {
    var source = document.querySelector('[data-gd-header-logo]');
    var destination = document.querySelector('[data-gd-footer-logo]');
    if (!source || !destination) return;
    destination.replaceChildren.apply(destination, Array.from(source.childNodes, function (node) { return node.cloneNode(true); }));
    destination.setAttribute('aria-label', source.getAttribute('aria-label') || '');
    destination.style.setProperty('--gd-logo-width-mobile', source.style.getPropertyValue('--gd-logo-width-mobile'));
    destination.style.setProperty('--gd-logo-width-desktop', source.style.getPropertyValue('--gd-logo-width-desktop'));
    var image = destination.querySelector('img');
    if (image) {
      image.loading = 'lazy';
      image.removeAttribute('fetchpriority');
    }
  }

  function initValueStrip(scope) {
    scope.querySelectorAll('[data-gd-value-track]').forEach(function (track) {
      if (track.dataset.gdBound) return;
      track.dataset.gdBound = 'true';
      var dots = Array.from(track.closest('.gd-value-strip').querySelectorAll('[data-gd-value-page]'));
      var mobile = window.matchMedia('(max-width: 899px)');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var inView = false;
      var timer;
      function syncPlayback() {
        window.clearInterval(timer);
        timer = null;
        if (!inView || !mobile.matches || reducedMotion.matches || document.hidden || dots.length < 2) return;
        timer = window.setInterval(function () {
          if (!track.isConnected) { window.clearInterval(timer); return; }
          var page = Math.round(track.scrollLeft / track.clientWidth);
          track.scrollTo({ left: ((page + 1) % dots.length) * track.clientWidth, behavior: 'smooth' });
        }, 3000);
      }
      function updateDots() {
        if (!dots.length || !track.clientWidth) return;
        var page = Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === page);
          dot.setAttribute('aria-pressed', String(index === page));
        });
      }
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          track.scrollTo({ left: index * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          syncPlayback();
        });
      });
      track.addEventListener('scroll', updateDots, { passive: true });
      var observer = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        syncPlayback();
      }, { threshold: 0.25 });
      observer.observe(track);
      mobile.addEventListener('change', syncPlayback);
      reducedMotion.addEventListener('change', syncPlayback);
      document.addEventListener('visibilitychange', syncPlayback);
    });
  }

  function ready() {
    document.documentElement.classList.add('gd-js');
    syncFooterLogo();
    var menu = document.querySelector('[data-gd-mobile-menu]');
    var toggle = document.querySelector('[data-gd-menu-toggle]');
    function setMenu(open, trigger) {
      if (!menu) return;
      if (!open && menu.contains(document.activeElement)) {
        var returnFocus = lastMenuTrigger && document.contains(lastMenuTrigger) ? lastMenuTrigger : toggle;
        if (returnFocus) returnFocus.focus();
      }
      menu.toggleAttribute('inert', !open);
      menu.classList.toggle('is-open', open); menu.setAttribute('aria-hidden', String(!open));
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('gd-menu-open', open);
      if (open) {
        lastMenuTrigger = trigger || document.activeElement;
        var menuClose = menu.querySelector('[data-gd-menu-close]');
        if (menuClose) menuClose.focus();
      } else {
        lastMenuTrigger = null;
      }
    }
    if (toggle && !toggle.dataset.gdBound) { toggle.dataset.gdBound = 'true'; toggle.addEventListener('click', function () { setMenu(true, toggle); }); }
    document.querySelectorAll('[data-gd-menu-close]').forEach(function (node) { if (!node.dataset.gdBound) { node.dataset.gdBound = 'true'; node.addEventListener('click', function () { setMenu(false); }); } });
    document.querySelectorAll('[data-gd-cart-close]').forEach(function (node) { if (!node.dataset.gdBound) { node.dataset.gdBound = 'true'; node.addEventListener('click', closeDrawer); } });
    document.querySelectorAll('[data-gd-cart-link]').forEach(function (node) { if (!node.dataset.gdBound) { node.dataset.gdBound = 'true'; node.addEventListener('click', function (event) { if (document.body && document.body.dataset.gdQuickCartEnabled === 'false') return; event.preventDefault(); openDrawer(node); }); } });
    document.querySelectorAll('[data-gd-mobile-cart-open]').forEach(function (node) { if (!node.dataset.gdBound) { node.dataset.gdBound = 'true'; node.addEventListener('click', function (event) { if (document.body && document.body.dataset.gdQuickCartEnabled === 'false') return; event.preventDefault(); openDrawer(node); }); } });
    bindMobileCartCheckout();
    document.querySelectorAll('[data-gd-sort]').forEach(function (select) { if (!select.dataset.gdBound) { select.dataset.gdBound = 'true'; select.addEventListener('change', function () { select.form.requestSubmit(); }); } });
    document.querySelectorAll('[data-gd-newsletter-note], [data-gd-popup-newsletter-note], [data-gd-quiz-contact-note]').forEach(function (note) {
      var form = note.form;
      if (!form || form.dataset.gdNoteBound) return;
      form.dataset.gdNoteBound = 'true';
      form.addEventListener('submit', function () {
        var phone = form.querySelector('[name="contact[phone]"], [data-gd-quiz-whatsapp]');
        if (phone && phone.value) note.value = 'WhatsApp: ' + phone.value;
      });
    });
    initSortPickers(document);
    document.querySelectorAll('[data-gd-product-root]').forEach(initProduct);
    initProductCards(document);
    initCampaignSingleProducts(document);
    bindAddForms(document);
    initMobileHeaderSearch();
    initSearch();
    initReveal(document);
    initQuickView();
    initRecentlyViewed();
    initCartPage();
    initShippingCalculators(document);
    initCollection(document);
    initRecommendations();
    initFavorites();
    initBulkAdd(document);
    initAmbientMedia(document);
    initCollectionShowcases(document);
    initCareStories(document);
    initHeaderScroll(document);
    initValueStrip(document);
    initKitQuiz(document);
    initScrollHints(document);
    initNotifyDialogs(document);
    initCategoryDropdown(document);
    initPrimaryDropdown(document);
    initLookbooks(document);
    initSocialVideos(document);
    initBannerSlideshows(document);
    initBestSellers(document);
    initDemoReviews();
    initBackToTop();
    initCommerceAnalytics();
    bindTermsGuard(document);
    if (!document.documentElement.dataset.gdTermsGuardBound) {
      document.documentElement.dataset.gdTermsGuardBound = 'true';
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.matches('[data-gd-main-cart-checkout-form]')) return;
        if (!document.body || document.body.dataset.gdTermsRequired !== 'true') return;
        var scope = form.closest('[data-gd-cart-page]') || document;
        var terms = scope.querySelector('[data-gd-cart-terms]');
        if (terms && terms.checked) return;
        event.preventDefault();
        if (terms) terms.focus();
        showToast('Aceite os termos para continuar ao checkout.');
      }, true);
      document.addEventListener('click', function (event) {
        var payment = event.target.closest && event.target.closest('[data-gd-payment-button]');
        if (!payment || !checkoutTermsRequired() || termsAccepted()) return;
        event.preventDefault();
        var terms = payment.closest('form') && payment.closest('form').querySelector('[data-gd-cart-terms]');
        if (terms) terms.focus();
        showToast('Aceite os termos para continuar ao checkout.');
      }, true);
    }
    initMobileCartNudge();
    if (!document.documentElement.dataset.gdCartEventBound) {
      document.documentElement.dataset.gdCartEventBound = 'true';
      document.addEventListener('gd:cart:updated', function (event) {
        if (event.detail && event.detail.cart) {
          if (window.GDShippingUI) window.GDShippingUI.invalidate();
          updateCommercialProgress(event.detail.cart);
          updateMobileCartPreview(event.detail.cart);
        }
      });
    }
    request(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (cart) {
      setCartCount(cart.item_count);
      updateShippingCalculatorVisibility(cart);
      updateMobileCartPreview(cart);
      updateCommercialProgress(cart);
    }).catch(function () { /* Keep the preview hidden until the next successful cart interaction. */ });
    if (!document.documentElement.dataset.gdEscapeBound) {
      document.documentElement.dataset.gdEscapeBound = 'true';
      document.addEventListener('keydown', function (event) {
        if (document.querySelector('dialog[open]')) return;
        if (event.key === 'Escape') { closeDrawer(); setMenu(false); }
        if (event.key !== 'Tab') return;
        var activeDialog = document.querySelector('[data-gd-cart-drawer].is-open .gd-cart-drawer__panel, [data-gd-mobile-menu].is-open');
        if (!activeDialog) return;
        var focusable = activeDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }
  }
  function initDemoReviews() {
    var root = document.querySelector('[data-gd-demo-reviews]');
    if (!root) return;
    if (root.dataset.gdReviewsBound) return;
    root.dataset.gdReviewsBound = 'true';
    var filters = root.querySelectorAll('[data-gd-filter]');
    var items = root.querySelectorAll('.gd-demo-reviews__item');
    var empty = root.querySelector('[data-gd-empty]');

    filters.forEach(function(filter) {
      filter.setAttribute('aria-pressed', filter.classList.contains('is-active') ? 'true' : 'false');
      filter.addEventListener('click', function() {
        var value = this.getAttribute('data-gd-filter');

        filters.forEach(function(f) { f.classList.remove('is-active'); f.setAttribute('aria-pressed', 'false'); });
        this.classList.add('is-active');
        this.setAttribute('aria-pressed', 'true');

        var visibleCount = 0;
        items.forEach(function(item) {
          var itemRating = item.getAttribute('data-gd-rating');
          if (value === 'all' || value === itemRating) {
            item.style.display = '';
            visibleCount++;
          } else {
            item.style.display = 'none';
          }
        });

        if (empty) {
          empty.hidden = visibleCount > 0;
        }
      });
    });
  }


  window.GDThemeShared = {
    rootUrl: rootUrl,
    money: money,
    request: request,
    showToast: showToast,
    setCartCount: setCartCount,
    updateMobileCartPreview: updateMobileCartPreview,
    gdCart: gdCart,
    addItemsToCart: addItemsToCart,
    afterAdd: afterAdd,
    renderDrawerFast: renderDrawerFast
  };

  if (window.__GD_THEME_TEST_HOOK__) {
    window.__GD_THEME_TEST_HOOK__({
      afterAdd: afterAdd,
      appendUniqueCollectionCards: appendUniqueCollectionCards,
      renderThresholdRecommendation: renderThresholdRecommendation,
      quickCartEnabled: quickCartEnabled,
      trackCommerceEvent: trackCommerceEvent,
      bindTermsGuard: bindTermsGuard,
      bindLoadMoreButton: bindLoadMoreButton,
      rewardSubtotal: rewardSubtotal,
      commercialGoals: commercialGoals,
      updateShippingCardBadge: updateShippingCardBadge,
      recordProductPageAdd: recordProductPageAdd,
      isManagedRewardGift: isManagedRewardGift,
      claimRewardGift: claimRewardGift,
      reconcileManagedGifts: reconcileManagedGifts,
      productPurchaseActionsPassed: productPurchaseActionsPassed,
      syncProductPurchaseVisibility: syncProductPurchaseVisibility
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', ready);
  document.addEventListener('shopify:section:unload', function (event) { cleanupAmbientMedia(event.target); });
})();

(function () {
  'use strict';
  function dateAtNoon(year, month, day) {
    return new Date(year, month, day, 12, 0, 0, 0);
  }

  function addDays(date, days) {
    var result = new Date(date.getTime());
    result.setDate(result.getDate() + days);
    return result;
  }

  function easterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return dateAtNoon(year, month - 1, day);
  }

  function nthWeekday(year, month, weekday, occurrence) {
    var first = dateAtNoon(year, month, 1);
    var offset = (weekday - first.getDay() + 7) % 7;
    return dateAtNoon(year, month, 1 + offset + (occurrence - 1) * 7);
  }

  function inRange(now, start, end) {
    return now >= start && now <= end;
  }

  function resolveSeasonalCampaign() {
    var mode = document.body.getAttribute('data-gd-seasonal-mode');
    if (!mode || mode === 'off') return;
    if (mode === 'manual') {
      var theme = document.body.getAttribute('data-gd-seasonal-theme');
      if (theme) document.documentElement.setAttribute('data-active-campaign', theme);
      return;
    }

    var current = new Date();
    var now = dateAtNoon(current.getFullYear(), current.getMonth(), current.getDate());
    var year = now.getFullYear();
    var easter = easterSunday(year);
    var carnival = addDays(easter, -47);
    var mothersDay = nthWeekday(year, 4, 0, 2);
    var fathersDay = nthWeekday(year, 7, 0, 2);
    var blackFriday = nthWeekday(year, 10, 5, 4);
    var campaign = '';

    if (inRange(now, dateAtNoon(year, 0, 1), dateAtNoon(year, 0, 6)) || inRange(now, dateAtNoon(year, 11, 26), dateAtNoon(year, 11, 31))) campaign = 'ano_novo';
    else if (inRange(now, addDays(carnival, -7), addDays(carnival, 1))) campaign = 'carnaval';
    else if (inRange(now, dateAtNoon(year, 2, 5), dateAtNoon(year, 2, 8))) campaign = 'dia_da_mulher';
    else if (inRange(now, addDays(easter, -14), easter)) campaign = 'pascoa';
    else if (inRange(now, addDays(mothersDay, -14), mothersDay)) campaign = 'dia_das_maes';
    else if (inRange(now, dateAtNoon(year, 5, 1), dateAtNoon(year, 5, 12))) campaign = 'dia_dos_namorados';
    else if (inRange(now, dateAtNoon(year, 5, 13), dateAtNoon(year, 6, 15))) campaign = 'festa_junina';
    else if (inRange(now, addDays(fathersDay, -14), fathersDay)) campaign = 'dia_dos_pais';
    else if (inRange(now, dateAtNoon(year, 8, 15), dateAtNoon(year, 8, 30))) campaign = 'primavera';
    else if (inRange(now, dateAtNoon(year, 9, 1), dateAtNoon(year, 9, 12))) campaign = 'dia_das_criancas';
    else if (inRange(now, addDays(blackFriday, -7), addDays(blackFriday, 3))) campaign = 'black_friday';
    else if (inRange(now, dateAtNoon(year, 11, 1), dateAtNoon(year, 11, 25))) campaign = 'natal';

    if (campaign) {
      document.documentElement.setAttribute('data-active-campaign', campaign);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resolveSeasonalCampaign);
  } else {
    resolveSeasonalCampaign();
  }
})();
